import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { API_URL } from '../config';
import { situacaoExameMap } from '../utils/situacaoExame';
import './DataPage.css';

// Collapsible section component
const CollapsibleSection = ({ title, defaultOpen = true, badge, borderColor, children }) => {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div style={{
      backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      marginBottom: '24px', overflow: 'hidden',
      borderLeft: borderColor ? `4px solid ${borderColor}` : undefined,
    }}>
      <div
        onClick={() => setOpen(!open)}
        style={{
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          padding: '16px 24px', cursor: 'pointer', userSelect: 'none',
          backgroundColor: open ? '#fff' : '#fafafa',
          borderBottom: open ? '1px solid #f0f0f0' : 'none',
          transition: 'background-color 0.15s ease',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>{title}</h3>
          {badge && <span style={{ fontSize: '12px', padding: '2px 8px', borderRadius: '10px', backgroundColor: badge.bg || '#e3f2fd', color: badge.color || '#1976d2', fontWeight: '500' }}>{badge.text}</span>}
        </div>
        <span style={{
          fontSize: '18px', color: '#999', transition: 'transform 0.2s ease',
          transform: open ? 'rotate(180deg)' : 'rotate(0deg)', lineHeight: 1,
        }}>&#9660;</span>
      </div>
      {open && <div style={{ padding: '24px' }}>{children}</div>}
    </div>
  );
};

const WhatsAppConfig = () => {
  const [activeTab, setActiveTab] = useState('conexao');
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [testando, setTestando] = useState(false);
  const [showToken, setShowToken] = useState(false);
  const [showWahaApikey, setShowWahaApikey] = useState(false);
  const [showFalavipPassword, setShowFalavipPassword] = useState(false);
  const [savedKeys, setSavedKeys] = useState({ access_token: false, waha_apikey: false, chatwoot_api_token: false, falavip_password: false });

  // Configurações da API
  const [config, setConfig] = useState({
    provedor_envio: 'waha',
    phone_number_id: '',
    access_token: '',
    nome_laboratorio: 'Laboratório Santa Rita',
    waba_id: '',
    waha_url: '',
    waha_session: '',
    waha_apikey: '',
    chatwoot_url: '',
    chatwoot_account_id: '',
    chatwoot_inbox_id: '',
    chatwoot_api_token: '',
    mensagem_texto: '✅ *Resultados Disponíveis*\n\nOlá, *{nome_paciente}*!\n\nSeus exames do protocolo *{protocolo}* de {data_atendimento} já estão prontos.\n\n📋 Acesse seus resultados:\n{link_resultado}\n\n🏥 *{nome_laboratorio}*\n_Cuidando da sua saúde!_',
  });

  // Template ativo (salvo no config)
  const [templateAtivo, setTemplateAtivo] = useState({
    template_name: '',
    template_language: 'pt_BR',
    template_variables: '',
    template_header_type: 'NONE',
  });

  // Templates da conta Meta
  const [templates, setTemplates] = useState([]);
  const [loadingTemplates, setLoadingTemplates] = useState(false);
  const [templateFilter, setTemplateFilter] = useState('');
  const [templateStatusFilter, setTemplateStatusFilter] = useState('');
  const [templateCategoryFilter, setTemplateCategoryFilter] = useState('');

  // Criar template
  const [showCreateForm, setShowCreateForm] = useState(false);
  const [creatingTemplate, setCreatingTemplate] = useState(false);
  const [newTemplate, setNewTemplate] = useState({
    name: '',
    language: 'pt_BR',
    category: 'UTILITY',
    allow_category_change: true,
    header_type: 'TEXT',
    header_text: '',
    header_file: null,
    body_text: '',
    footer_text: '',
    example_values: [],
  });
  const [uploadingFile, setUploadingFile] = useState(false);

  // Preview de template (smartphone mockup)
  const [previewTemplate, setPreviewTemplate] = useState(null);

  // Modal de seleção/mapeamento de variáveis
  const [showSelectModal, setShowSelectModal] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [variableMapping, setVariableMapping] = useState([]);

  // Exclusão
  const [deletingTemplate, setDeletingTemplate] = useState(null);

  // Auto-detectar WABA
  const [detectingWaba, setDetectingWaba] = useState(false);

  // WAHA Templates (locais)
  const [wahaTemplates, setWahaTemplates] = useState([]);
  const [loadingWahaTemplates, setLoadingWahaTemplates] = useState(false);
  const [wahaTemplateAtivo, setWahaTemplateAtivo] = useState(null);
  const [showWahaForm, setShowWahaForm] = useState(false);
  const [editingWahaTemplate, setEditingWahaTemplate] = useState(null);
  const [wahaFormData, setWahaFormData] = useState({
    nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum'
  });

  // Mensagens Diretas (session messages)
  const [msgDiretaModelos, setMsgDiretaModelos] = useState([]);
  const [loadingMsgDireta, setLoadingMsgDireta] = useState(false);
  const [msgDiretaModeloAtivo, setMsgDiretaModeloAtivo] = useState(null);
  const [showMsgDiretaForm, setShowMsgDiretaForm] = useState(false);
  const [editingMsgDireta, setEditingMsgDireta] = useState(null);
  const [msgDiretaFormData, setMsgDiretaFormData] = useState({
    nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum'
  });

  // Header image
  const [headerImageUrl, setHeaderImageUrl] = useState(null);
  const [uploadingHeaderImage, setUploadingHeaderImage] = useState(false);
  const [headerImageError, setHeaderImageError] = useState('');

  // Dados de exemplo para preview de template
  const [previewExampleData, setPreviewExampleData] = useState(null);

  // Regras de envio
  const [regrasEnvio, setRegrasEnvio] = useState({
    envio_politica: 'tat',
    envio_espera_max_dias: '4',
    envio_max_mensagens: '2',
    envio_esperar_lentos: '0',
    envio_delay_minutos: '10',
    envio_percentual_minimo: '100',
    data_corte_envios: '',
    dias_retroativos: '14',
    envio_exigir_pdf: '0',
    envio_usar_pdf_interno: '0',
    tat_envio_inteligente: '0',
    envio_exigir_pagamento: '0',
    envio_pagamento_dias_retroativos: '7',
    envio_notificar_nao_pago: '0',
    mensagem_nao_pago: 'Olá, {primeiro_nome}! Seus exames do protocolo {protocolo} de {data_atendimento} já estão prontos, porém não identificamos o pagamento. Regularize na recepção para liberarmos o envio automático do resultado. {nome_laboratorio}',
    fechar_conversa_apos_envio: '0',
  });
  // TAT Cache
  const [tatCache, setTatCache] = useState(null);
  const [loadingTatCache, setLoadingTatCache] = useState(false);
  const [showTatLista, setShowTatLista] = useState(false);
  const [tatFiltroCategoria, setTatFiltroCategoria] = useState('todos');
  const [tatBusca, setTatBusca] = useState('');
  const [proximosEnvios, setProximosEnvios] = useState(null);
  const [loadingProximos, setLoadingProximos] = useState(false);
  const [proximosFiltro, setProximosFiltro] = useState('todos');
  const [proximosBusca, setProximosBusca] = useState('');
  const [proximosPagina, setProximosPagina] = useState(1);
  const PROXIMOS_POR_PAGINA = 20;

  // Agendamento (com campos do worker)
  const [agendamento, setAgendamento] = useState({
    ativo: false,
    horario: '08:00',
    dias_semana: [],
    status_exame: 'I',
    apenas_com_consentimento: true,
    horario_inicio: '07:00',
    horario_fim: '22:00',
    intervalo_minutos: 3,
    max_envios_ciclo: 20,
    modo_resposta: 'sequencia',
  });

  // Worker status (polling)
  const [workerStatus, setWorkerStatus] = useState(null);
  const [workerHistorico, setWorkerHistorico] = useState([]);
  const [showHistorico, setShowHistorico] = useState(false);

  useEffect(() => {
    carregarConfiguracoes();
    carregarAgendamento();
    carregarWahaTemplates();
    carregarMsgDiretaModelos();
    carregarHeaderImage();
    carregarExemploReal();
    carregarWorkerStatus();
    carregarTatCache();
  }, []);

  // Polling do worker status a cada 10s quando na aba regras
  useEffect(() => {
    if (activeTab !== 'regras') return;
    const interval = setInterval(carregarWorkerStatus, 10000);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  // Auto-carregar templates do cache local quando abre a aba "template"
  // Sincronização com a Meta só acontece quando o usuário clica em "Sincronizar com Meta"
  useEffect(() => {
    if (activeTab === 'templates' && config.provedor_envio === 'meta' && templates.length === 0 && !loadingTemplates) {
      const loadCache = async () => {
        try {
          const cacheResp = await axios.get(`${API_URL}/whatsapp/templates/cache`);
          if (cacheResp.data && cacheResp.data.length > 0) {
            setTemplates(cacheResp.data);
          }
        } catch (e) { /* ignore */ }
      };
      loadCache();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, config.provedor_envio]);

  // Carregar próximos envios ao entrar na aba regras
  useEffect(() => {
    if (activeTab === 'regras') {
      carregarProximosEnvios();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  const carregarProximosEnvios = async () => {
    setLoadingProximos(true);
    try {
      const res = await axios.get(`${API_URL}/whatsapp/worker/proximos?limit=500`);
      setProximosEnvios(res.data);
    } catch (err) {
      console.error('Erro ao carregar próximos envios:', err);
    } finally {
      setLoadingProximos(false);
    }
  };

  const showMessage = (texto, tipo) => {
    setMessage({ texto, tipo });
    setTimeout(() => setMessage(null), 5000);
  };

  const carregarConfiguracoes = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/config`);
      const data = response.data;
      setConfig({
        provedor_envio: data.provedor_envio || 'waha',
        phone_number_id: data.phone_number_id || '',
        access_token: data.access_token || '',
        nome_laboratorio: data.nome_laboratorio || 'Laboratório Santa Rita',
        waba_id: data.waba_id || '',
        waha_url: data.waha_url || '',
        waha_session: data.waha_session || '',
        waha_apikey: data.waha_apikey || '',
        chatwoot_url: data.chatwoot_url || '',
        chatwoot_account_id: data.chatwoot_account_id || '',
        chatwoot_inbox_id: data.chatwoot_inbox_id || '',
        chatwoot_api_token: data.chatwoot_api_token || '',
        mensagem_texto: data.mensagem_texto || 'Olá {nome_paciente}, seus exames do protocolo {protocolo} de {data_atendimento} já estão prontos!\n\nAcesse seus resultados:\n{link_resultado}\n\n{nome_laboratorio}',
        telefone_teste: data.telefone_teste || '',
      });
      setTemplateAtivo({
        template_name: data.template_name || '',
        template_language: data.template_language || 'pt_BR',
        template_variables: data.template_variables || '',
        template_header_type: data.template_header_type || 'NONE',
      });
      setSavedKeys({
        access_token: !!data.access_token_saved,
        waha_apikey: !!data.waha_apikey_saved,
        chatwoot_api_token: !!data.chatwoot_api_token_saved,
        falavip_password: !!data.falavip_password_saved,
      });
      setRegrasEnvio({
        envio_politica: data.envio_politica || 'tat',
        envio_espera_max_dias: data.envio_espera_max_dias || '4',
        envio_max_mensagens: data.envio_max_mensagens || '2',
        envio_esperar_lentos: data.envio_esperar_lentos || '0',
        envio_delay_minutos: data.envio_delay_minutos || '10',
        envio_percentual_minimo: data.envio_percentual_minimo || '100',
        data_corte_envios: data.data_corte_envios || '',
        dias_retroativos: data.dias_retroativos || '14',
        envio_exigir_pdf: data.envio_exigir_pdf || '0',
        envio_usar_pdf_interno: data.envio_usar_pdf_interno || '0',
        tat_envio_inteligente: data.tat_envio_inteligente || '0',
        envio_exigir_pagamento: data.envio_exigir_pagamento || '0',
        envio_pagamento_dias_retroativos: data.envio_pagamento_dias_retroativos || '7',
        envio_notificar_nao_pago: data.envio_notificar_nao_pago || '0',
        mensagem_nao_pago: data.mensagem_nao_pago || 'Olá, {primeiro_nome}! Seus exames do protocolo {protocolo} de {data_atendimento} já estão prontos, porém não identificamos o pagamento. Regularize na recepção para liberarmos o envio automático do resultado. {nome_laboratorio}',
        fechar_conversa_apos_envio: data.fechar_conversa_apos_envio || '0',
      });
    } catch (error) {
      console.error('Erro ao carregar configurações:', error);
    }
  };

  // === Header Image helpers ===
  const carregarHeaderImage = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/header-image`, { responseType: 'blob' });
      const url = URL.createObjectURL(response.data);
      setHeaderImageUrl(url);
    } catch {
      setHeaderImageUrl(null);
    }
  };

  const comprimirImagem = (file, maxSizeKB = 900) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.onload = () => {
          const canvas = document.createElement('canvas');
          let { width, height } = img;

          // Redimensionar se muito grande (manter ratio 1.91:1 ideal para WhatsApp)
          const MAX_WIDTH = 800;
          if (width > MAX_WIDTH) {
            height = Math.round(height * (MAX_WIDTH / width));
            width = MAX_WIDTH;
          }

          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);

          // Tentar JPEG com qualidade decrescente até caber
          let quality = 0.9;
          let result;
          do {
            result = canvas.toDataURL('image/jpeg', quality);
            quality -= 0.1;
          } while (result.length > maxSizeKB * 1024 * 1.37 && quality > 0.1);

          // Extrair base64 sem o prefixo data:image/jpeg;base64,
          const base64 = result.split(',')[1];
          const sizeKB = Math.round(base64.length * 0.75 / 1024);
          resolve({ base64, mimetype: 'image/jpeg', sizeKB, previewUrl: result });
        };
        img.onerror = () => reject(new Error('Erro ao carregar imagem'));
        img.src = e.target.result;
      };
      reader.onerror = () => reject(new Error('Erro ao ler arquivo'));
      reader.readAsDataURL(file);
    });
  };

  const handleHeaderImageUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
      setHeaderImageError('Selecione um arquivo de imagem (PNG, JPG)');
      return;
    }

    setUploadingHeaderImage(true);
    setHeaderImageError('');

    try {
      const { base64, mimetype, sizeKB } = await comprimirImagem(file, 900);

      await axios.post(`${API_URL}/whatsapp/header-image`, {
        image_base64: base64,
        mimetype,
      });

      showMessage(`Imagem salva com sucesso (${sizeKB}KB)`, 'sucesso');
      await carregarHeaderImage();
    } catch (err) {
      const msg = err.response?.data?.error || err.message || 'Erro ao enviar imagem';
      setHeaderImageError(msg);
    } finally {
      setUploadingHeaderImage(false);
      e.target.value = '';
    }
  };

  const removerHeaderImage = async () => {
    try {
      await axios.delete(`${API_URL}/whatsapp/header-image`);
      setHeaderImageUrl(null);
      showMessage('Imagem removida', 'sucesso');
    } catch (err) {
      showMessage('Erro ao remover imagem', 'erro');
    }
  };

  // Carregar dados reais de um exame pronto para usar como exemplo no preview
  const carregarExemploReal = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/resultados`, {
        params: { apenasComWhatsapp: 'false', status: 'I' }
      });
      const resultados = response.data || [];
      const exemplo = resultados.find(r => r.EXAMES_PRONTOS > 0 && r.PACIENTE_NOME) || resultados[0];
      if (exemplo) {
        const primeiroNome = (exemplo.PACIENTE_NOME || '').split(' ')[0];
        const data = exemplo.DATA_ATENDIMENTO
          ? new Date(exemplo.DATA_ATENDIMENTO).toLocaleDateString('pt-BR')
          : '19/02/2026';
        const LOCAL_NOMES = { '01': 'Matriz', '02': 'Itapecerica', '04': 'Pedra do Indaiá', 'CA': 'Camacho' };
        const localNome = LOCAL_NOMES[(exemplo.LOCAL || '').trim()] || 'Itapecerica';
        const protocolo = String(exemplo.PROTOCOLO || '258920');
        setPreviewExampleData({
          nome_paciente: exemplo.PACIENTE_NOME || 'Maria Silva Santos',
          primeiro_nome: primeiroNome || 'Maria',
          protocolo,
          data_atendimento: data,
          local_nome: localNome,
          nome_laboratorio: config.nome_laboratorio || 'Laboratório Santa Rita',
          link_resultado: 'http://app.lifesys.com.br/laudos/#/login...',
          protocolo_data: `${protocolo} de ${data}`,
          data_protocolo: `${data}, protocolo ${protocolo}`,
          data_local: `${data} na unidade ${localNome}`,
          info_atendimento: `Protocolo ${protocolo} - ${data}`,
          acesse_link: 'Acesse seus resultados: http://app.lifesys...',
          lab_assinatura: `${config.nome_laboratorio || 'Laboratório Santa Rita'} - Cuidando da sua saúde!`,
          status_exames: `Todos os seus ${exemplo.EXAMES_PRONTOS || 3} exame(s) estão prontos!`,
          total_exames: String(exemplo.TOTAL_EXAMES || 3),
          exames_prontos: String(exemplo.EXAMES_PRONTOS || 3),
        });
      }
    } catch {
      // Fallback com dados estáticos
      setPreviewExampleData(null);
    }
  };

  const carregarAgendamento = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/agendamento`);
      const data = response.data;
      const diasStr = data.dias_semana || '1,2,3,4,5';
      const diasArr = typeof diasStr === 'string' ? diasStr.split(',').map(Number).filter(Boolean) : diasStr;
      setAgendamento({
        ativo: data.ativo ? true : false,
        horario: data.horario || '08:00',
        dias_semana: diasArr,
        status_exame: data.status_exame || 'I',
        apenas_com_consentimento: data.apenas_com_consentimento !== undefined ? (data.apenas_com_consentimento ? true : false) : true,
        horario_inicio: data.horario_inicio || '07:00',
        horario_fim: data.horario_fim || '22:00',
        intervalo_minutos: data.intervalo_minutos || 3,
        max_envios_ciclo: data.max_envios_ciclo || 20,
        modo_resposta: data.modo_resposta || 'sequencia',
      });
    } catch (error) {
      console.error('Erro ao carregar agendamento:', error);
    }
  };

  const testarConexao = async () => {
    setTestando(true);
    try {
      await axios.post(`${API_URL}/whatsapp/testar-conexao`);
      showMessage('Conexão estabelecida com sucesso!', 'sucesso');
    } catch (error) {
      const msg = error.response?.data?.error || 'Falha ao testar conexão. Verifique as credenciais.';
      showMessage(msg, 'erro');
    } finally {
      setTestando(false);
    }
  };

  const salvarConfig = async () => {
    setLoading(true);
    try {
      await axios.put(`${API_URL}/whatsapp/config`, {
        provedor_envio: config.provedor_envio,
        phone_number_id: config.phone_number_id,
        access_token: config.access_token,
        nome_laboratorio: config.nome_laboratorio,
        waba_id: config.waba_id,
        waha_url: config.waha_url,
        waha_session: config.waha_session,
        waha_apikey: config.waha_apikey,
        chatwoot_url: config.chatwoot_url,
        chatwoot_account_id: config.chatwoot_account_id,
        chatwoot_inbox_id: config.chatwoot_inbox_id,
        chatwoot_api_token: config.chatwoot_api_token,
        mensagem_texto: config.mensagem_texto,
      });
      showMessage('Configurações da API salvas com sucesso!', 'sucesso');
      carregarConfiguracoes();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar configurações.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const autoDetectWaba = async () => {
    setDetectingWaba(true);
    try {
      const response = await axios.post(`${API_URL}/whatsapp/templates/auto-detect-waba`);
      setConfig(prev => ({ ...prev, waba_id: response.data.waba_id }));
      showMessage(`WABA ID detectado: ${response.data.waba_id}`, 'sucesso');
    } catch (error) {
      const msg = error.response?.data?.error || 'Falha ao detectar WABA ID.';
      showMessage(msg, 'erro');
    } finally {
      setDetectingWaba(false);
    }
  };

  // --- Templates ---

  const buscarTemplates = async () => {
    setLoadingTemplates(true);
    try {
      const params = new URLSearchParams();
      if (templateStatusFilter) params.append('status', templateStatusFilter);
      if (templateCategoryFilter) params.append('category', templateCategoryFilter);
      if (templateFilter) params.append('name_or_content', templateFilter);
      const response = await axios.get(`${API_URL}/whatsapp/templates?${params.toString()}`);
      setTemplates(response.data);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao buscar templates.';
      showMessage(msg, 'erro');
    } finally {
      setLoadingTemplates(false);
    }
  };

  const criarTemplate = async () => {
    if (!newTemplate.name || !newTemplate.body_text) {
      showMessage('Nome e corpo do template são obrigatórios.', 'erro');
      return;
    }
    if (!/^[a-z][a-z0-9_]*$/.test(newTemplate.name)) {
      showMessage('Nome deve ser lowercase, começar com letra, e conter apenas letras, números e underscores.', 'erro');
      return;
    }

    setCreatingTemplate(true);
    try {
      // Se header é DOCUMENT, usar fluxo com upload
      if (newTemplate.header_type === 'DOCUMENT') {
        if (!newTemplate.header_file) {
          showMessage('Para template com documento, envie um PDF de exemplo.', 'erro');
          setCreatingTemplate(false);
          return;
        }

        // Etapa 1: Upload do arquivo para Meta
        setUploadingFile(true);
        const formData = new FormData();
        formData.append('file', newTemplate.header_file);

        let handle;
        try {
          const uploadResp = await axios.post(`${API_URL}/whatsapp/templates/upload-media`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
          });
          handle = uploadResp.data.handle;
        } catch (uploadErr) {
          const msg = uploadErr.response?.data?.error || 'Erro ao fazer upload do arquivo.';
          showMessage(msg, 'erro');
          setCreatingTemplate(false);
          setUploadingFile(false);
          return;
        }
        setUploadingFile(false);

        // Etapa 2: Criar template com handle
        const bodyVars = newTemplate.body_text.match(/\{\{\d+\}\}/g) || [];
        await axios.post(`${API_URL}/whatsapp/templates/with-document`, {
          name: newTemplate.name,
          language: newTemplate.language,
          category: newTemplate.category,
          body_text: newTemplate.body_text,
          footer_text: newTemplate.footer_text || undefined,
          header_handle: handle,
          example_values: bodyVars.length > 0 ? newTemplate.example_values.slice(0, bodyVars.length) : undefined,
          allow_category_change: newTemplate.allow_category_change,
        });
      } else {
        // Fluxo padrão (header TEXT ou sem header)
        const components = [];

        if (newTemplate.header_text) {
          components.push({ type: 'HEADER', format: 'TEXT', text: newTemplate.header_text });
        }

        const bodyComponent = { type: 'BODY', text: newTemplate.body_text };
        const bodyVars = newTemplate.body_text.match(/\{\{\d+\}\}/g) || [];
        if (bodyVars.length > 0 && newTemplate.example_values.length > 0) {
          bodyComponent.example = {
            body_text: [newTemplate.example_values.slice(0, bodyVars.length)]
          };
        }
        components.push(bodyComponent);

        if (newTemplate.footer_text) {
          components.push({ type: 'FOOTER', text: newTemplate.footer_text });
        }

        await axios.post(`${API_URL}/whatsapp/templates`, {
          name: newTemplate.name,
          language: newTemplate.language,
          category: newTemplate.category,
          components,
          allow_category_change: newTemplate.allow_category_change,
        });
      }

      showMessage('Template criado com sucesso! Aguardando aprovação da Meta.', 'sucesso');
      setShowCreateForm(false);
      setNewTemplate({
        name: '', language: 'pt_BR', category: 'UTILITY', allow_category_change: true,
        header_type: 'TEXT', header_text: '', header_file: null,
        body_text: '', footer_text: '', example_values: [],
      });
      buscarTemplates();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao criar template.';
      showMessage(msg, 'erro');
    } finally {
      setCreatingTemplate(false);
      setUploadingFile(false);
    }
  };

  const excluirTemplate = async (templateName) => {
    setDeletingTemplate(templateName);
    try {
      await axios.delete(`${API_URL}/whatsapp/templates/${encodeURIComponent(templateName)}`);
      showMessage(`Template "${templateName}" excluído com sucesso.`, 'sucesso');
      setTemplates(prev => prev.filter(t => t.name !== templateName));
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir template.';
      showMessage(msg, 'erro');
    } finally {
      setDeletingTemplate(null);
    }
  };

  const abrirModalSelecao = (tmpl) => {
    setSelectedTemplate(tmpl);
    // Extrair variáveis do body
    const bodyComp = tmpl.components?.find(c => c.type === 'BODY');
    const bodyText = bodyComp?.text || '';
    const vars = bodyText.match(/\{\{\d+\}\}/g) || [];
    setVariableMapping(vars.map(() => ''));
    setShowSelectModal(true);
  };

  const selecionarTemplate = async () => {
    if (!selectedTemplate) return;
    setLoading(true);
    try {
      const variaveisStr = variableMapping.join(',');
      const headerComp = selectedTemplate.components?.find(c => c.type === 'HEADER');
      const headerType = headerComp?.format || 'NONE';
      await axios.post(`${API_URL}/whatsapp/templates/selecionar`, {
        template_name: selectedTemplate.name,
        template_language: selectedTemplate.language,
        template_variables: variaveisStr,
        template_header_type: headerType,
      });
      setTemplateAtivo({
        template_name: selectedTemplate.name,
        template_language: selectedTemplate.language,
        template_variables: variaveisStr,
        template_header_type: headerType,
      });
      showMessage(`Template "${selectedTemplate.name}" selecionado para envio.`, 'sucesso');
      setShowSelectModal(false);
      setSelectedTemplate(null);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao selecionar template.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  // --- WAHA Templates ---
  const carregarWahaTemplates = async () => {
    setLoadingWahaTemplates(true);
    try {
      const response = await axios.get(`${API_URL}/whatsapp/waha-templates`);
      setWahaTemplates(response.data);
      const ativo = response.data.find(t => t.ativo);
      setWahaTemplateAtivo(ativo || null);
    } catch (error) {
      console.error('Erro ao carregar templates WAHA:', error);
    } finally {
      setLoadingWahaTemplates(false);
    }
  };

  const salvarWahaTemplate = async () => {
    if (!wahaFormData.nome || !wahaFormData.mensagem_texto) {
      showMessage('Nome e texto da mensagem são obrigatórios.', 'erro');
      return;
    }
    setLoading(true);
    try {
      if (editingWahaTemplate) {
        await axios.put(`${API_URL}/whatsapp/waha-templates/${editingWahaTemplate.id}`, wahaFormData);
        showMessage('Template atualizado com sucesso.', 'sucesso');
      } else {
        await axios.post(`${API_URL}/whatsapp/waha-templates`, wahaFormData);
        showMessage('Template criado com sucesso.', 'sucesso');
      }
      setShowWahaForm(false);
      setEditingWahaTemplate(null);
      setWahaFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
      carregarWahaTemplates();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar template.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const excluirWahaTemplate = async (id) => {
    try {
      await axios.delete(`${API_URL}/whatsapp/waha-templates/${id}`);
      showMessage('Template excluído com sucesso.', 'sucesso');
      carregarWahaTemplates();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir template.';
      showMessage(msg, 'erro');
    }
  };

  const ativarWahaTemplate = async (id) => {
    try {
      await axios.post(`${API_URL}/whatsapp/waha-templates/${id}/ativar`);
      showMessage('Template ativado com sucesso.', 'sucesso');
      carregarWahaTemplates();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao ativar template.';
      showMessage(msg, 'erro');
    }
  };

  const abrirEditarWahaTemplate = (tmpl) => {
    setEditingWahaTemplate(tmpl);
    setWahaFormData({
      nome: tmpl.nome,
      descricao: tmpl.descricao || '',
      mensagem_texto: tmpl.mensagem_texto,
      tipo_anexo: tmpl.tipo_anexo || 'nenhum',
    });
    setShowWahaForm(true);
  };

  const abrirNovoWahaTemplate = () => {
    setEditingWahaTemplate(null);
    setWahaFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
    setShowWahaForm(true);
  };

  // --- Mensagens Diretas ---
  const carregarMsgDiretaModelos = async () => {
    setLoadingMsgDireta(true);
    try {
      const response = await axios.get(`${API_URL}/whatsapp/mensagens-diretas`);
      setMsgDiretaModelos(response.data);
      const ativo = response.data.find(t => t.ativo);
      setMsgDiretaModeloAtivo(ativo || null);
    } catch (error) {
      console.error('Erro ao carregar modelos de mensagem direta:', error);
    } finally {
      setLoadingMsgDireta(false);
    }
  };

  const salvarMsgDiretaModelo = async () => {
    if (!msgDiretaFormData.nome || !msgDiretaFormData.mensagem_texto) {
      showMessage('Nome e texto da mensagem são obrigatórios.', 'erro');
      return;
    }
    setLoading(true);
    try {
      if (editingMsgDireta) {
        await axios.put(`${API_URL}/whatsapp/mensagens-diretas/${editingMsgDireta.id}`, msgDiretaFormData);
        showMessage('Modelo atualizado com sucesso.', 'sucesso');
      } else {
        await axios.post(`${API_URL}/whatsapp/mensagens-diretas`, msgDiretaFormData);
        showMessage('Modelo criado com sucesso.', 'sucesso');
      }
      setShowMsgDiretaForm(false);
      setEditingMsgDireta(null);
      setMsgDiretaFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
      carregarMsgDiretaModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar modelo.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const excluirMsgDiretaModelo = async (id) => {
    try {
      await axios.delete(`${API_URL}/whatsapp/mensagens-diretas/${id}`);
      showMessage('Modelo excluído com sucesso.', 'sucesso');
      carregarMsgDiretaModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao excluir modelo.';
      showMessage(msg, 'erro');
    }
  };

  const ativarMsgDiretaModelo = async (id) => {
    try {
      await axios.post(`${API_URL}/whatsapp/mensagens-diretas/${id}/ativar`);
      showMessage('Modelo ativado com sucesso.', 'sucesso');
      carregarMsgDiretaModelos();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao ativar modelo.';
      showMessage(msg, 'erro');
    }
  };

  const abrirEditarMsgDireta = (modelo) => {
    setEditingMsgDireta(modelo);
    setMsgDiretaFormData({
      nome: modelo.nome,
      descricao: modelo.descricao || '',
      mensagem_texto: modelo.mensagem_texto,
      tipo_anexo: modelo.tipo_anexo || 'nenhum',
    });
    setShowMsgDiretaForm(true);
  };

  const abrirNovoMsgDireta = () => {
    setEditingMsgDireta(null);
    setMsgDiretaFormData({ nome: '', descricao: '', mensagem_texto: '', tipo_anexo: 'nenhum' });
    setShowMsgDiretaForm(true);
  };

  const salvarAgendamento = async () => {
    setLoading(true);
    try {
      const payload = {
        ...agendamento,
        ativo: agendamento.ativo ? 1 : 0,
        dias_semana: Array.isArray(agendamento.dias_semana) ? agendamento.dias_semana.join(',') : agendamento.dias_semana,
        apenas_com_consentimento: agendamento.apenas_com_consentimento ? 1 : 0,
      };
      await axios.put(`${API_URL}/whatsapp/agendamento`, payload);
      showMessage('Configuracao salva com sucesso!', 'sucesso');

      // Se ativou, iniciar worker; se desativou, parar
      if (agendamento.ativo) {
        try { await axios.post(`${API_URL}/whatsapp/worker/iniciar`); } catch (e) { /* ignora */ }
      } else {
        try { await axios.post(`${API_URL}/whatsapp/worker/parar`); } catch (e) { /* ignora */ }
      }
      await carregarWorkerStatus();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar configuracao.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  // Worker functions
  const carregarWorkerStatus = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/worker/status`);
      setWorkerStatus(response.data);
    } catch (e) {
      // Ignora se endpoint ainda não existe
    }
  };

  const executarCicloAgora = async () => {
    try {
      await axios.post(`${API_URL}/whatsapp/worker/executar-agora`);
      showMessage('Ciclo iniciado manualmente!', 'sucesso');
      setTimeout(carregarWorkerStatus, 2000);
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao executar ciclo.';
      showMessage(msg, 'erro');
    }
  };

  const carregarHistoricoWorker = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/worker/historico`);
      setWorkerHistorico(response.data);
      setShowHistorico(true);
    } catch (error) {
      showMessage('Erro ao carregar historico.', 'erro');
    }
  };

  const salvarRegrasEnvio = async () => {
    setLoading(true);
    try {
      await axios.put(`${API_URL}/whatsapp/config`, regrasEnvio);
      showMessage('Regras de envio salvas com sucesso!', 'sucesso');
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar regras de envio.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const carregarTatCache = async () => {
    try {
      const response = await axios.get(`${API_URL}/whatsapp/tat-cache`);
      setTatCache(response.data);
    } catch (error) {
      console.error('Erro ao carregar TAT cache:', error);
    }
  };

  const atualizarTatCache = async () => {
    setLoadingTatCache(true);
    try {
      const response = await axios.post(`${API_URL}/whatsapp/tat-cache/atualizar`);
      showMessage(`Cache TAT atualizado: ${response.data.total} exames classificados.`, 'sucesso');
      carregarTatCache();
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao atualizar cache TAT.';
      showMessage(msg, 'erro');
    } finally {
      setLoadingTatCache(false);
    }
  };

  const salvarTudo = async () => {
    setLoading(true);
    try {
      // Salvar regras de envio (delay, percentual)
      await axios.put(`${API_URL}/whatsapp/config`, regrasEnvio);

      // Salvar agendamento (envio automatico + modo resposta)
      const payload = {
        ...agendamento,
        ativo: agendamento.ativo ? 1 : 0,
        dias_semana: Array.isArray(agendamento.dias_semana) ? agendamento.dias_semana.join(',') : agendamento.dias_semana,
        apenas_com_consentimento: agendamento.apenas_com_consentimento ? 1 : 0,
      };
      await axios.put(`${API_URL}/whatsapp/agendamento`, payload);

      // Gerenciar worker
      if (agendamento.ativo) {
        try { await axios.post(`${API_URL}/whatsapp/worker/iniciar`); } catch (e) { /* ignora */ }
      } else {
        try { await axios.post(`${API_URL}/whatsapp/worker/parar`); } catch (e) { /* ignora */ }
      }
      await carregarWorkerStatus();
      showMessage('Todas as configuracoes salvas com sucesso!', 'sucesso');
    } catch (error) {
      const msg = error.response?.data?.error || 'Erro ao salvar configuracoes.';
      showMessage(msg, 'erro');
    } finally {
      setLoading(false);
    }
  };

  const toggleDiaSemana = (dia) => {
    setAgendamento((prev) => {
      const dias = prev.dias_semana.includes(dia)
        ? prev.dias_semana.filter((d) => d !== dia)
        : [...prev.dias_semana, dia];
      return { ...prev, dias_semana: dias };
    });
  };

  // Helper: Atualizar example_values quando body_text muda
  const handleBodyTextChange = (text) => {
    const vars = text.match(/\{\{\d+\}\}/g) || [];
    setNewTemplate(prev => ({
      ...prev,
      body_text: text,
      example_values: vars.map((_, i) => prev.example_values[i] || ''),
    }));
  };

  // Helper: status badge
  const getStatusBadge = (status) => {
    const map = {
      APPROVED: { bg: '#e8f5e9', color: '#2e7d32', label: 'Aprovado' },
      PENDING: { bg: '#fff8e1', color: '#f57f17', label: 'Pendente' },
      REJECTED: { bg: '#ffebee', color: '#c62828', label: 'Rejeitado' },
      PAUSED: { bg: '#f3e5f5', color: '#7b1fa2', label: 'Pausado' },
      DISABLED: { bg: '#eceff1', color: '#546e7a', label: 'Desativado' },
    };
    const s = map[status] || { bg: '#eceff1', color: '#546e7a', label: status };
    return (
      <span style={{
        padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500',
        backgroundColor: s.bg, color: s.color, whiteSpace: 'nowrap',
      }}>
        {s.label}
      </span>
    );
  };

  const getCategoryLabel = (cat) => {
    const map = { UTILITY: 'Utilidade', MARKETING: 'Marketing', AUTHENTICATION: 'Autenticação' };
    return map[cat] || cat;
  };

  // Variáveis disponíveis para mapeamento
  const variaveisDisponiveis = [
    // Nome do paciente (para {{1}} - após "Olá")
    { value: 'nome_paciente', label: 'Nome completo', group: 'Nome (para saudação)', example: 'Maria Silva Santos' },
    { value: 'primeiro_nome', label: 'Primeiro nome', group: 'Nome (para saudação)', example: 'Maria' },
    // Variáveis inteligentes (recomendadas para {{2}} - incluem link + continuam naturalmente no texto fixo)
    { value: 'corpo_seu_exame', label: '⭐ Corpo para "seu_exame_"', group: 'Template Inteligente (recomendado)',
      example: '258920 de 19/02/2026 na unidade Itapecerica. 📋 Acesse: http://app.lifesys.com.br/laudos/#/login... - Laboratório Santa Rita. Todo o processo' },
    { value: 'corpo_pedido_pronto', label: '⭐ Corpo para "pedido_pronto"', group: 'Template Inteligente (recomendado)',
      example: '19/02/2026 na unidade Itapecerica (protocolo 258920). 📋 Acesse: http://app.lifesys.com.br/laudos/#/login... - Laboratório Santa Rita. O resultado' },
    // Contexto do exame (para {{2}} - referência ao exame/data)
    { value: 'protocolo_data', label: 'Protocolo + data', group: 'Contexto do Exame', example: '258920 de 19/02/2026' },
    { value: 'data_protocolo', label: 'Data + protocolo', group: 'Contexto do Exame', example: '19/02/2026, protocolo 258920' },
    { value: 'data_local', label: 'Data + unidade', group: 'Contexto do Exame', example: '19/02/2026 na unidade Itapecerica' },
    { value: 'info_atendimento', label: 'Protocolo - Data (completo)', group: 'Contexto do Exame', example: 'Protocolo 258920 - 19/02/2026' },
    // Dados simples
    { value: 'protocolo', label: 'Numero do protocolo', group: 'Dados Simples', example: '258920' },
    { value: 'data_atendimento', label: 'Data do atendimento', group: 'Dados Simples', example: '19/02/2026' },
    { value: 'local_nome', label: 'Nome da unidade', group: 'Dados Simples', example: 'Itapecerica' },
    { value: 'nome_laboratorio', label: 'Nome do laboratorio', group: 'Dados Simples', example: 'Laboratorio Santa Rita' },
    { value: 'link_resultado', label: 'Link de acesso ao resultado', group: 'Dados Simples', example: 'http://app.lifesys.com.br/laudos/#/login...' },
    // Texto completo (para WAHA/Diretas)
    { value: 'acesse_link', label: 'Texto + link do resultado', group: 'Texto Completo', example: 'Acesse seus resultados: http://app.lifesys...' },
    { value: 'lab_assinatura', label: 'Assinatura do laboratorio', group: 'Texto Completo', example: 'Laboratorio Santa Rita - Cuidando da sua saude!' },
    // Exames
    { value: 'status_exames', label: 'Status dos exames (resumo)', group: 'Exames', example: 'Todos os seus 5 exame(s) estao prontos!' },
    { value: 'total_exames', label: 'Total de exames (numero)', group: 'Exames', example: '5' },
    { value: 'exames_prontos', label: 'Exames prontos (numero)', group: 'Exames', example: '5' },
  ];

  // ===== Estilos =====
  const containerStyle = { backgroundColor: '#f5f5f5', minHeight: '100vh' };
  const pageHeaderStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
    flexWrap: 'wrap',
    gap: '12px',
  };
  const pageIconStyle = {
    fontSize: '1.5rem',
    lineHeight: 1,
  };
  const pageTitleStyle = {
    fontSize: '1.5rem',
    fontWeight: '700',
    color: '#1a1a2e',
    margin: '0 0 2px 0',
  };
  const pageSubtitleStyle = {
    fontSize: '0.85rem',
    color: '#666',
    margin: 0,
  };
  const cardStyle = {
    backgroundColor: '#fff', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    padding: '24px', marginBottom: '24px',
  };
  const tabContainerStyle = {
    display: 'flex', borderBottom: '1px solid #e0e0e0', marginBottom: '24px',
    backgroundColor: '#fff', borderRadius: '8px 8px 0 0', boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
    padding: '0 8px',
  };
  const tabStyle = {
    padding: '14px 24px', fontSize: '14px', fontWeight: '500', cursor: 'pointer',
    border: 'none', background: 'none', color: '#666', borderBottom: '3px solid transparent',
    transition: 'all 0.2s ease', outline: 'none',
  };
  const tabActiveStyle = { ...tabStyle, fontWeight: '600', color: '#1976d2', borderBottom: '3px solid #1976d2' };
  const labelStyle = { display: 'block', fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px' };
  const inputStyle = {
    width: '100%', padding: '10px 12px', fontSize: '14px', border: '1px solid #ddd',
    borderRadius: '6px', color: '#333', outline: 'none', boxSizing: 'border-box',
    transition: 'border-color 0.2s ease',
  };
  const selectStyle = { ...inputStyle, appearance: 'auto' };
  const fieldGroupStyle = { marginBottom: '20px' };
  const btnPrimary = {
    padding: '10px 24px', fontSize: '14px', fontWeight: '500', color: '#fff',
    backgroundColor: '#1976d2', border: 'none', borderRadius: '6px', cursor: 'pointer',
    transition: 'background-color 0.2s ease',
  };
  const btnSecondary = {
    padding: '10px 24px', fontSize: '14px', fontWeight: '500', color: '#1976d2',
    backgroundColor: '#fff', border: '1px solid #1976d2', borderRadius: '6px',
    cursor: 'pointer', transition: 'all 0.2s ease',
  };
  const btnSmall = {
    padding: '10px 16px', fontSize: '13px', fontWeight: '500', color: '#666',
    backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '0 6px 6px 0',
    cursor: 'pointer', whiteSpace: 'nowrap',
  };
  const btnDanger = {
    padding: '6px 14px', fontSize: '13px', fontWeight: '500', color: '#c62828',
    backgroundColor: '#fff', border: '1px solid #ef9a9a', borderRadius: '6px',
    cursor: 'pointer',
  };
  const btnSuccess = {
    padding: '6px 14px', fontSize: '13px', fontWeight: '500', color: '#fff',
    backgroundColor: '#2e7d32', border: 'none', borderRadius: '6px', cursor: 'pointer',
  };
  const messageStyle = (tipo) => ({
    padding: '12px 16px', borderRadius: '6px', fontSize: '14px', marginBottom: '20px',
    backgroundColor: tipo === 'sucesso' ? '#e8f5e9' : '#ffebee',
    color: tipo === 'sucesso' ? '#2e7d32' : '#c62828',
    border: `1px solid ${tipo === 'sucesso' ? '#c8e6c9' : '#ffcdd2'}`,
  });
  const helpTextStyle = { fontSize: '12px', color: '#999', marginTop: '4px' };
  const toggleContainerStyle = { display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '20px' };
  const toggleStyle = (ativo) => ({
    width: '48px', height: '24px', borderRadius: '12px', backgroundColor: ativo ? '#1976d2' : '#ccc',
    position: 'relative', cursor: 'pointer', transition: 'background-color 0.2s ease',
    border: 'none', outline: 'none', padding: 0,
  });
  const toggleKnobStyle = (ativo) => ({
    width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#fff',
    position: 'absolute', top: '2px', left: ativo ? '26px' : '2px',
    transition: 'left 0.2s ease', boxShadow: '0 1px 2px rgba(0,0,0,0.2)',
  });
  const checkboxGroupStyle = { display: 'flex', flexWrap: 'wrap', gap: '12px', marginTop: '6px' };
  const checkboxLabelStyle = (checked) => ({
    display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 14px',
    borderRadius: '6px', border: `1px solid ${checked ? '#1976d2' : '#ddd'}`,
    backgroundColor: checked ? '#e3f2fd' : '#fff', color: checked ? '#1976d2' : '#666',
    fontSize: '13px', fontWeight: '500', cursor: 'pointer', transition: 'all 0.2s ease', userSelect: 'none',
  });
  const avisoStyle = {
    padding: '12px 16px', borderRadius: '6px', fontSize: '13px', backgroundColor: '#fff8e1',
    color: '#f57f17', border: '1px solid #ffecb3', marginBottom: '20px', lineHeight: '1.5',
  };
  const buttonRowStyle = { display: 'flex', alignItems: 'center', gap: '12px', marginTop: '24px' };
  const overlayStyle = {
    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center',
    zIndex: 1000,
  };
  const modalStyle = {
    backgroundColor: '#fff', borderRadius: '12px', padding: '32px', maxWidth: '560px',
    width: '90%', maxHeight: '80vh', overflowY: 'auto', boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
  };
  const tableStyle = {
    width: '100%', borderCollapse: 'collapse', fontSize: '14px',
  };
  const thStyle = {
    padding: '10px 12px', textAlign: 'left', borderBottom: '2px solid #e0e0e0',
    color: '#666', fontWeight: '600', fontSize: '13px', backgroundColor: '#fafafa',
  };
  const tdStyle = {
    padding: '10px 12px', borderBottom: '1px solid #f0f0f0', color: '#333',
  };

  const diasSemana = [
    { valor: 1, label: 'Seg' }, { valor: 2, label: 'Ter' }, { valor: 3, label: 'Qua' },
    { valor: 4, label: 'Qui' }, { valor: 5, label: 'Sex' }, { valor: 6, label: 'Sáb' },
    { valor: 7, label: 'Dom' },
  ];

  // ===== Phone Preview Helper =====

  const renderPhonePreview = (tmpl, exampleValues) => {
    if (!tmpl) return null;
    const header = tmpl.components?.find(c => c.type === 'HEADER');
    const body = tmpl.components?.find(c => c.type === 'BODY');
    const footer = tmpl.components?.find(c => c.type === 'FOOTER');
    const rawBodyText = body?.text || '';
    const bodyExamples = exampleValues || body?.example?.body_text?.[0] || [];

    // Gerar partes do body com variáveis destacadas
    const bodyParts = [];
    let lastIdx = 0;
    const varRegex = /\{\{(\d+)\}\}/g;
    let match;
    while ((match = varRegex.exec(rawBodyText)) !== null) {
      if (match.index > lastIdx) {
        bodyParts.push({ type: 'text', value: rawBodyText.slice(lastIdx, match.index) });
      }
      const varNum = parseInt(match[1]);
      const exValue = bodyExamples[varNum - 1] || `[variável ${varNum}]`;
      bodyParts.push({ type: 'var', value: exValue });
      lastIdx = match.index + match[0].length;
    }
    if (lastIdx < rawBodyText.length) {
      bodyParts.push({ type: 'text', value: rawBodyText.slice(lastIdx) });
    }

    const agora = new Date();
    const hora = agora.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });

    return (
      <div style={{
        width: '320px', height: '580px', borderRadius: '36px', overflow: 'hidden',
        border: '8px solid #1a1a1a', backgroundColor: '#e5ddd5', position: 'relative',
        boxShadow: '0 8px 32px rgba(0,0,0,0.3)', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        {/* Status bar */}
        <div style={{
          height: '28px', backgroundColor: '#075e54', display: 'flex',
          alignItems: 'center', justifyContent: 'space-between', padding: '0 16px',
          fontSize: '11px', color: '#fff',
        }}>
          <span>{hora}</span>
          <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
            <span style={{ fontSize: '9px' }}>4G</span>
            <span>■■■</span>
            <span style={{ fontSize: '13px' }}>🔋</span>
          </div>
        </div>

        {/* WhatsApp header */}
        <div style={{
          height: '52px', backgroundColor: '#075e54', display: 'flex',
          alignItems: 'center', padding: '0 12px', gap: '10px',
        }}>
          <span style={{ fontSize: '18px', color: '#fff', cursor: 'pointer' }}>←</span>
          <div style={{
            width: '36px', height: '36px', borderRadius: '50%', backgroundColor: '#25d366',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: '16px', color: '#fff', fontWeight: '700',
          }}>
            L
          </div>
          <div>
            <div style={{ fontSize: '14px', fontWeight: '600', color: '#fff' }}>
              {config.nome_laboratorio || 'Laboratório'}
            </div>
            <div style={{ fontSize: '11px', color: '#b0d4b0' }}>online</div>
          </div>
        </div>

        {/* Chat area */}
        <div style={{
          flex: 1, height: 'calc(100% - 80px - 48px)', overflowY: 'auto',
          padding: '12px 10px',
          backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'200\' height=\'200\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cdefs%3E%3Cpattern id=\'a\' patternUnits=\'userSpaceOnUse\' width=\'40\' height=\'40\'%3E%3Cpath d=\'M0 20h40M20 0v40\' fill=\'none\' stroke=\'%23d4cfc4\' stroke-width=\'.3\'/%3E%3C/pattern%3E%3C/defs%3E%3Crect fill=\'%23e5ddd5\' width=\'200\' height=\'200\'/%3E%3Crect fill=\'url(%23a)\' width=\'200\' height=\'200\'/%3E%3C/svg%3E")',
        }}>
          {/* Message bubble */}
          <div style={{
            maxWidth: '260px', backgroundColor: '#fff', borderRadius: '0 8px 8px 8px',
            padding: '0', boxShadow: '0 1px 2px rgba(0,0,0,0.13)', marginLeft: '4px',
            overflow: 'hidden',
          }}>
            {/* Document header */}
            {header?.format === 'DOCUMENT' && (
              <div style={{
                backgroundColor: '#f0f0f0', padding: '12px', display: 'flex',
                alignItems: 'center', gap: '10px', borderBottom: '1px solid #e0e0e0',
              }}>
                <div style={{
                  width: '36px', height: '42px', backgroundColor: '#e53935', borderRadius: '4px',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  color: '#fff', fontSize: '10px', fontWeight: '700',
                }}>
                  PDF
                </div>
                <div>
                  <div style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>
                    resultado_exame.pdf
                  </div>
                  <div style={{ fontSize: '11px', color: '#999' }}>
                    Documento PDF
                  </div>
                </div>
              </div>
            )}

            {/* Image header */}
            {header?.format === 'IMAGE' && (
              <div style={{ borderBottom: '1px solid #e0e0e0' }}>
                <img src={headerImageUrl || 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="300" height="157"%3E%3Crect fill="%23e8e8e8" width="300" height="157"/%3E%3Ctext x="50%25" y="50%25" fill="%23999" font-size="14" text-anchor="middle" dy=".3em"%3EImagem do Header%3C/text%3E%3C/svg%3E'}
                  alt="Header" style={{ width: '100%', height: 'auto', display: 'block', maxHeight: '140px', objectFit: 'cover' }} />
              </div>
            )}

            {/* Text header */}
            {header?.format === 'TEXT' && header.text && (
              <div style={{
                padding: '8px 10px 0', fontSize: '14px', fontWeight: '700', color: '#333',
              }}>
                {header.text}
              </div>
            )}

            {/* Body */}
            <div style={{
              padding: '8px 10px 2px', fontSize: '13.5px', color: '#303030',
              lineHeight: '1.45', whiteSpace: 'pre-wrap', wordBreak: 'break-word',
            }}>
              {bodyParts.map((part, i) =>
                part.type === 'var' ? (
                  <span key={i} style={{
                    color: '#0c5460', fontWeight: '500', fontSize: '12.5px',
                  }}>
                    {part.value}
                  </span>
                ) : (
                  <span key={i}>{part.value}</span>
                )
              )}
            </div>

            {/* Footer + time */}
            <div style={{
              padding: '0 10px 6px', display: 'flex', justifyContent: 'space-between',
              alignItems: 'flex-end',
            }}>
              {footer?.text ? (
                <div style={{ fontSize: '11px', color: '#8696a0', flex: 1 }}>
                  {footer.text}
                </div>
              ) : <div />}
              <div style={{ fontSize: '10px', color: '#8696a0', whiteSpace: 'nowrap', marginLeft: '8px' }}>
                {hora}
              </div>
            </div>
          </div>

          {/* Botões do template (QUICK_REPLY / URL / PHONE_NUMBER) */}
          {(() => {
            const buttons = tmpl.components?.find(c => c.type === 'BUTTONS');
            if (!buttons?.buttons?.length) return null;
            return (
              <div style={{ maxWidth: '260px', marginLeft: '4px', marginTop: '2px' }}>
                {buttons.buttons.map((btn, idx) => (
                  <div key={idx} style={{
                    backgroundColor: '#fff', borderRadius: '8px', padding: '8px 12px',
                    marginTop: idx === 0 ? 0 : '2px', textAlign: 'center',
                    boxShadow: '0 1px 2px rgba(0,0,0,0.08)', cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px',
                  }}>
                    {btn.type === 'URL' && <span style={{ fontSize: '12px' }}>🔗</span>}
                    {btn.type === 'PHONE_NUMBER' && <span style={{ fontSize: '12px' }}>📞</span>}
                    <span style={{ fontSize: '13px', color: '#00a5f4', fontWeight: '500' }}>
                      {btn.text}
                    </span>
                  </div>
                ))}
              </div>
            );
          })()}
        </div>

        {/* Input bar */}
        <div style={{
          height: '48px', backgroundColor: '#f0f0f0', display: 'flex',
          alignItems: 'center', padding: '0 8px', gap: '8px',
          borderTop: '1px solid #ddd',
        }}>
          <span style={{ fontSize: '20px' }}>😊</span>
          <div style={{
            flex: 1, height: '34px', backgroundColor: '#fff', borderRadius: '17px',
            padding: '0 14px', display: 'flex', alignItems: 'center',
            fontSize: '13px', color: '#999',
          }}>
            Mensagem
          </div>
          <span style={{ fontSize: '18px' }}>🎤</span>
        </div>
      </div>
    );
  };

  // ===== Renders =====

  const renderConfigAPI = () => (
    <div>
      {/* Seleção de provedor */}
      <div style={cardStyle}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '4px' }}>
          Provedor de Envio
        </h3>
        <p style={{ fontSize: '12px', color: '#666', marginTop: 0, marginBottom: '16px' }}>
          Escolha o canal pelo qual o sistema enviará as mensagens de WhatsApp.
        </p>
        <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))', gap: '12px' }}>
          {[
            { value: 'waha', icon: '🟢', label: 'WAHA', subtitle: 'WhatsApp HTTP API', desc: 'Servidor WAHA próprio (não-oficial). Envio livre de mensagens e mídia.' },
            { value: 'meta', icon: '🔵', label: 'Meta Cloud API', subtitle: 'API oficial', desc: 'API oficial da Meta. Requer template aprovado para iniciar conversa.' },
            { value: 'chatwoot', icon: '💬', label: 'CRM (FalaVIP)', subtitle: 'Via FalaVIP API', desc: 'Encaminha o envio pela API do FalaVIP, que entrega no Chatwoot. A conversa fica no inbox do CRM.' },
          ].map(opt => {
            const selected = config.provedor_envio === opt.value;
            return (
              <label key={opt.value} style={{
                padding: '16px', borderRadius: '8px', cursor: 'pointer',
                border: `2px solid ${selected ? '#1976d2' : '#e0e0e0'}`,
                backgroundColor: selected ? '#e3f2fd' : '#fff',
                transition: 'all 0.2s ease',
                display: 'flex', flexDirection: 'column', gap: '6px',
              }}>
                <input type="radio" name="provedor" value={opt.value}
                  checked={selected}
                  onChange={(e) => setConfig({ ...config, provedor_envio: e.target.value })}
                  style={{ display: 'none' }} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ fontSize: '20px' }}>{opt.icon}</span>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '14px', color: selected ? '#1976d2' : '#333' }}>
                      {opt.label}
                    </div>
                    <div style={{ fontSize: '11px', color: '#888' }}>{opt.subtitle}</div>
                  </div>
                </div>
                <div style={{ fontSize: '12px', color: '#666', lineHeight: '1.4' }}>{opt.desc}</div>
              </label>
            );
          })}
        </div>
      </div>

      {/* Configurações CRM (FalaVIP) */}
      {config.provedor_envio === 'chatwoot' && (
        <div style={cardStyle}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '4px' }}>
            Configurações CRM (via FalaVIP)
          </h3>
          <p style={{ fontSize: '12px', color: '#666', marginTop: 0, marginBottom: '20px' }}>
            O envio passa pela API do FalaVIP, que cria/reaproveita o contato e a conversa no inbox indicado do Chatwoot e posta a mensagem como agente. Suporta texto e PDF.
          </p>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>URL da API FalaVIP</label>
            <input type="text" style={inputStyle} value={config.falavip_api_url || ''}
              onChange={(e) => setConfig({ ...config, falavip_api_url: e.target.value })}
              placeholder="https://apifalavip.viptecnologia.com.br" />
            <p style={helpTextStyle}>URL base da API do FalaVIP (sem barra final).</p>
          </div>

          <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Email (SuperAdmin)</label>
              <input type="email" style={inputStyle} value={config.falavip_email || ''}
                onChange={(e) => setConfig({ ...config, falavip_email: e.target.value })}
                placeholder="usuario@exemplo.com" />
              <p style={helpTextStyle}>Email de uma conta SuperAdmin no FalaVIP.</p>
            </div>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Senha {savedKeys.falavip_password && <span style={{ color: '#2e7d32', fontSize: '11px', fontWeight: '400' }}>(salva)</span>}</label>
              <div style={{ display: 'flex' }}>
                <input type={showFalavipPassword ? 'text' : 'password'}
                  style={{ ...inputStyle, borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                  value={config.falavip_password || ''}
                  onChange={(e) => {
                    setConfig({ ...config, falavip_password: e.target.value });
                    if (savedKeys.falavip_password) setSavedKeys(prev => ({ ...prev, falavip_password: false }));
                  }}
                  onFocus={(e) => { if ((config.falavip_password || '').startsWith('\u2022\u2022\u2022\u2022')) e.target.select(); }}
                  placeholder={savedKeys.falavip_password ? 'Senha salva - digite para alterar' : 'Senha da conta'} />
                <button type="button" style={btnSmall} onClick={() => setShowFalavipPassword(!showFalavipPassword)}>
                  {showFalavipPassword ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
              <p style={helpTextStyle}>O sistema faz login e cacheia o JWT (24h) automaticamente.</p>
            </div>
          </div>

          <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Account ID (Chatwoot)</label>
              <input type="text" style={inputStyle} value={config.falavip_account_id || ''}
                onChange={(e) => setConfig({ ...config, falavip_account_id: e.target.value })}
                placeholder="Ex: 20" />
              <p style={helpTextStyle}>ID da conta no Chatwoot (rota /app/accounts/&lt;id&gt;).</p>
            </div>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Inbox ID (Chatwoot)</label>
              <input type="text" style={inputStyle} value={config.falavip_inbox_id || ''}
                onChange={(e) => setConfig({ ...config, falavip_inbox_id: e.target.value })}
                placeholder="Ex: 58" />
              <p style={helpTextStyle}>ID do inbox WhatsApp de saída.</p>
            </div>
          </div>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Nome do Laboratório</label>
            <input type="text" style={inputStyle} value={config.nome_laboratorio}
              onChange={(e) => setConfig({ ...config, nome_laboratorio: e.target.value })}
              placeholder="Laboratório Santa Rita" />
          </div>

          <div className="responsive-flex" style={buttonRowStyle}>
            <button type="button" style={btnSecondary} onClick={testarConexao} disabled={testando}>
              {testando ? 'Testando...' : 'Testar Conexão'}
            </button>
            <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
              onClick={salvarConfig} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      {/* Configurações WAHA */}
      {config.provedor_envio === 'waha' && (
        <div style={cardStyle}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '20px' }}>
            Configurações WAHA
          </h3>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>URL do Servidor WAHA</label>
            <input type="text" style={inputStyle} value={config.waha_url}
              onChange={(e) => setConfig({ ...config, waha_url: e.target.value })}
              placeholder="https://wh.exemplo.com.br" />
          </div>

          <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Sessão</label>
              <input type="text" style={inputStyle} value={config.waha_session}
                onChange={(e) => setConfig({ ...config, waha_session: e.target.value })}
                placeholder="Ex: labsantarita" />
            </div>
            <div style={fieldGroupStyle}>
              <label style={labelStyle}>API Key {savedKeys.waha_apikey && <span style={{ color: '#2e7d32', fontSize: '11px', fontWeight: '400' }}>(salva)</span>}</label>
              <div style={{ display: 'flex' }}>
                <input type={showWahaApikey ? 'text' : 'password'}
                  style={{ ...inputStyle, borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                  value={config.waha_apikey}
                  onChange={(e) => {
                    setConfig({ ...config, waha_apikey: e.target.value });
                    if (savedKeys.waha_apikey) setSavedKeys(prev => ({ ...prev, waha_apikey: false }));
                  }}
                  onFocus={(e) => { if (config.waha_apikey.startsWith('\u2022\u2022\u2022\u2022')) e.target.select(); }}
                  placeholder={savedKeys.waha_apikey ? 'Chave salva - digite para alterar' : 'Chave de autenticação'} />
                <button type="button" style={btnSmall} onClick={() => setShowWahaApikey(!showWahaApikey)}>
                  {showWahaApikey ? 'Ocultar' : 'Mostrar'}
                </button>
              </div>
            </div>
          </div>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Nome do Laboratório</label>
            <input type="text" style={inputStyle} value={config.nome_laboratorio}
              onChange={(e) => setConfig({ ...config, nome_laboratorio: e.target.value })}
              placeholder="Laboratório Santa Rita" />
          </div>

          <div className="responsive-flex" style={buttonRowStyle}>
            <button type="button" style={btnSecondary} onClick={testarConexao} disabled={testando}>
              {testando ? 'Testando...' : 'Testar Conexão'}
            </button>
            <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
              onClick={salvarConfig} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}

      {/* Configurações Meta Cloud API */}
      {config.provedor_envio === 'meta' && (
        <div style={cardStyle}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '20px' }}>
            Configurações Meta Cloud API
          </h3>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Phone Number ID</label>
            <input type="text" style={inputStyle} value={config.phone_number_id}
              onChange={(e) => setConfig({ ...config, phone_number_id: e.target.value })}
              placeholder="Ex: 123456789012345" />
          </div>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Access Token {savedKeys.access_token && <span style={{ color: '#2e7d32', fontSize: '11px', fontWeight: '400' }}>(salvo)</span>}</label>
            <div style={{ display: 'flex' }}>
              <input type={showToken ? 'text' : 'password'}
                style={{ ...inputStyle, borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                value={config.access_token}
                onChange={(e) => {
                  setConfig({ ...config, access_token: e.target.value });
                  if (savedKeys.access_token) setSavedKeys(prev => ({ ...prev, access_token: false }));
                }}
                onFocus={(e) => { if (config.access_token.startsWith('\u2022\u2022\u2022\u2022')) e.target.select(); }}
                placeholder={savedKeys.access_token ? 'Token salvo - digite para alterar' : 'Token de acesso da API do WhatsApp'} />
              <button type="button" style={btnSmall} onClick={() => setShowToken(!showToken)}>
                {showToken ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
          </div>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>WABA ID (WhatsApp Business Account)</label>
            <div style={{ display: 'flex' }}>
              <input type="text"
                style={{ ...inputStyle, borderRadius: '6px 0 0 6px', borderRight: 'none' }}
                value={config.waba_id}
                onChange={(e) => setConfig({ ...config, waba_id: e.target.value })}
                placeholder="Ex: 123456789012345" />
              <button type="button" style={{
                ...btnSmall, backgroundColor: '#e3f2fd', color: '#1976d2',
                borderColor: '#90caf9', fontWeight: '500',
              }}
                onClick={autoDetectWaba} disabled={detectingWaba}>
                {detectingWaba ? 'Detectando...' : 'Auto-detectar'}
              </button>
            </div>
            <p style={helpTextStyle}>
              Necessário para gerenciar templates.
            </p>
          </div>

          <div style={fieldGroupStyle}>
            <label style={labelStyle}>Nome do Laboratório</label>
            <input type="text" style={inputStyle} value={config.nome_laboratorio}
              onChange={(e) => setConfig({ ...config, nome_laboratorio: e.target.value })}
              placeholder="Laboratório Santa Rita" />
          </div>

          <div className="responsive-flex" style={buttonRowStyle}>
            <button type="button" style={btnSecondary} onClick={testarConexao} disabled={testando}>
              {testando ? 'Testando...' : 'Testar Conexão'}
            </button>
            <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
              onClick={salvarConfig} disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar'}
            </button>
          </div>
        </div>
      )}
    </div>
  );

  const renderTemplate = () => {
    if (config.provedor_envio === 'waha' || config.provedor_envio === 'chatwoot') {
      return renderWahaTemplates();
    }
    return renderMetaTemplates();
  };

  const renderWahaTemplates = () => (
    <div>
      {/* Template ativo */}
      <CollapsibleSection title="Template Ativo" borderColor="#1976d2"
        badge={wahaTemplateAtivo ? { text: wahaTemplateAtivo.nome, bg: '#e3f2fd', color: '#1976d2' } : { text: 'Nenhum', bg: '#f5f5f5', color: '#999' }}>
        {wahaTemplateAtivo ? (
          <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', alignItems: 'center', marginBottom: '12px' }}>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Nome</span>
                <div style={{ fontSize: '15px', fontWeight: '500', color: '#1976d2' }}>
                  {wahaTemplateAtivo.nome}
                </div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Anexo</span>
                <div style={{ fontSize: '14px', color: '#333' }}>
                  {wahaTemplateAtivo.tipo_anexo === 'pdf_resultado' ? 'PDF do Resultado' : 'Nenhum'}
                </div>
              </div>
            </div>
            {/* Pré-visualização */}
            <div style={{
              backgroundColor: '#e7f5e4', borderRadius: '8px', padding: '16px',
              border: '1px solid #c8e6c9',
            }}>
              <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
              <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                dangerouslySetInnerHTML={{
                  __html: (wahaTemplateAtivo.mensagem_texto || '')
                    .replace(/\{nome_paciente\}/g, 'João da Silva')
                    .replace(/\{primeiro_nome\}/g, 'João')
                    .replace(/\{protocolo\}/g, '12345')
                    .replace(/\{data_atendimento\}/g, '12/02/2026')
                    .replace(/\{local_nome\}/g, 'Itapecerica')
                    .replace(/\{protocolo_data\}/g, '12345 de 12/02/2026')
                    .replace(/\{data_protocolo\}/g, '12/02/2026, protocolo 12345')
                    .replace(/\{data_local\}/g, '12/02/2026 na unidade Itapecerica')
                    .replace(/\{info_atendimento\}/g, 'Protocolo 12345 - 12/02/2026')
                    .replace(/\{nome_laboratorio\}/g, config.nome_laboratorio || 'Laboratório Santa Rita')
                    .replace(/\{link_resultado\}/g, 'http://app.lifesys.com.br/laudos/...')
                    .replace(/\{acesse_link\}/g, 'Acesse seus resultados: http://app.lifesys.com.br/laudos/...')
                    .replace(/\{lab_assinatura\}/g, (config.nome_laboratorio || 'Laboratório Santa Rita') + ' - Cuidando da sua saúde!')
                    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
                    .replace(/_([^_]+)_/g, '<em>$1</em>')
                    .replace(/~([^~]+)~/g, '<s>$1</s>')
                }} />
            </div>
          </div>
        ) : (
          <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>
            Nenhum template ativo. Crie um template e ative-o para uso no envio.
          </p>
        )}
      </CollapsibleSection>

      {/* Templates WAHA (Locais) */}
      <CollapsibleSection title="Templates WAHA (Locais)" defaultOpen={false}
        badge={{ text: `${wahaTemplates.length}`, bg: '#f5f5f5', color: '#666' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
          <button type="button" style={btnPrimary} onClick={abrirNovoWahaTemplate}>
            + Criar Novo
          </button>
        </div>

        {/* Formulário criar/editar */}
        {showWahaForm && (
          <div style={{
            backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
            padding: '24px', marginBottom: '20px',
          }}>
            <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
              {editingWahaTemplate ? 'Editar Template' : 'Criar Novo Template'}
            </h4>

            <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Nome *</label>
                <input type="text" style={inputStyle} value={wahaFormData.nome}
                  onChange={(e) => setWahaFormData({ ...wahaFormData, nome: e.target.value })}
                  placeholder="Ex: Resultado de Exame" />
              </div>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Tipo de Anexo</label>
                <select style={selectStyle} value={wahaFormData.tipo_anexo}
                  onChange={(e) => setWahaFormData({ ...wahaFormData, tipo_anexo: e.target.value })}>
                  <option value="nenhum">Nenhum (apenas texto)</option>
                  <option value="pdf_resultado">PDF do Resultado</option>
                </select>
              </div>
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Descrição</label>
              <input type="text" style={inputStyle} value={wahaFormData.descricao}
                onChange={(e) => setWahaFormData({ ...wahaFormData, descricao: e.target.value })}
                placeholder="Breve descrição do template" />
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Texto da Mensagem *</label>
              <textarea style={{ ...inputStyle, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
                value={wahaFormData.mensagem_texto}
                onChange={(e) => setWahaFormData({ ...wahaFormData, mensagem_texto: e.target.value })}
                placeholder="✅ *Resultados Disponíveis*\n\nOlá, *{nome_paciente}*!..." />
              <p style={helpTextStyle}>
                Basicas: {'{nome_paciente}'}, {'{primeiro_nome}'}, {'{protocolo}'}, {'{data_atendimento}'}, {'{local_nome}'}, {'{nome_laboratorio}'}, {'{link_resultado}'}
                <br />Compostas: {'{protocolo_data}'}, {'{data_protocolo}'}, {'{data_local}'}, {'{info_atendimento}'}, {'{acesse_link}'}, {'{lab_assinatura}'}
                <br />Exames: {'{status_exames}'}, {'{total_exames}'}, {'{exames_prontos}'}, {'{lista_exames}'}
                <br />Formatacao WhatsApp: *negrito*, _italico_, ~tachado~
              </p>
            </div>

            {/* Pré-visualização ao vivo */}
            {wahaFormData.mensagem_texto && (
              <div style={{
                backgroundColor: '#e7f5e4', borderRadius: '8px', padding: '16px', marginBottom: '16px',
                border: '1px solid #c8e6c9',
              }}>
                <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
                <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                  dangerouslySetInnerHTML={{
                    __html: wahaFormData.mensagem_texto
                      .replace(/\{nome_paciente\}/g, 'João da Silva')
                      .replace(/\{protocolo\}/g, '12345')
                      .replace(/\{data_atendimento\}/g, '12/02/2026')
                      .replace(/\{nome_laboratorio\}/g, config.nome_laboratorio || 'Laboratório Santa Rita')
                      .replace(/\{link_resultado\}/g, 'http://app.lifesys.com.br/laudos/...')
                      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                      .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
                      .replace(/_([^_]+)_/g, '<em>$1</em>')
                      .replace(/~([^~]+)~/g, '<s>$1</s>')
                  }} />
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
                onClick={salvarWahaTemplate} disabled={loading}>
                {loading ? 'Salvando...' : (editingWahaTemplate ? 'Salvar Alterações' : 'Criar Template')}
              </button>
              <button type="button" style={btnSecondary} onClick={() => { setShowWahaForm(false); setEditingWahaTemplate(null); }}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tabela de templates */}
        {loadingWahaTemplates ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            Carregando templates...
          </div>
        ) : wahaTemplates.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Descrição</th>
                  <th style={thStyle}>Anexo</th>
                  <th style={thStyle}>Status</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {wahaTemplates.map((tmpl, idx) => (
                  <tr key={tmpl.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ ...tdStyle, fontWeight: '500' }}>{tmpl.nome}</td>
                    <td style={{ ...tdStyle, color: '#666', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {tmpl.descricao || '-'}
                    </td>
                    <td style={tdStyle}>
                      {tmpl.tipo_anexo === 'pdf_resultado' ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                          PDF
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Nenhum</span>
                      )}
                    </td>
                    <td style={tdStyle}>
                      {tmpl.ativo ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#e8f5e9', color: '#2e7d32' }}>
                          Ativo
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Inativo</span>
                      )}
                    </td>
                    <td style={{ ...tdStyle, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {!tmpl.ativo && (
                        <button type="button" style={{ ...btnSuccess, marginRight: '8px' }}
                          onClick={() => ativarWahaTemplate(tmpl.id)}>
                          Ativar
                        </button>
                      )}
                      <button type="button" style={{ ...btnSecondary, padding: '6px 14px', fontSize: '13px', marginRight: '8px' }}
                        onClick={() => abrirEditarWahaTemplate(tmpl)}>
                        Editar
                      </button>
                      {!tmpl.ativo && (
                        <button type="button" style={btnDanger}
                          onClick={() => {
                            if (window.confirm(`Excluir o template "${tmpl.nome}"?`)) {
                              excluirWahaTemplate(tmpl.id);
                            }
                          }}>
                          Excluir
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            <p style={{ fontSize: '14px', margin: 0 }}>Nenhum template encontrado.</p>
            <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
              Clique em "Criar Novo" para adicionar um template de mensagem.
            </p>
          </div>
        )}
      </CollapsibleSection>
    </div>
  );

  const renderMetaTemplates = () => (
    <div>
      {/* Template ativo com preview */}
      <CollapsibleSection title="Template Ativo" borderColor="#1976d2"
        badge={templateAtivo.template_name ? { text: templateAtivo.template_name, bg: '#e3f2fd', color: '#1976d2' } : { text: 'Nenhum', bg: '#f5f5f5', color: '#999' }}>
        {templateAtivo.template_name ? (
          <div style={{ display: 'flex', gap: '32px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
            {/* Info do template */}
            <div style={{ flex: '1 1 280px', minWidth: '240px' }}>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '16px' }}>
                <div>
                  <span style={{ fontSize: '12px', color: '#999' }}>Nome</span>
                  <div style={{ fontSize: '15px', fontWeight: '500', color: '#1976d2' }}>
                    {templateAtivo.template_name}
                  </div>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#999' }}>Idioma</span>
                  <div style={{ fontSize: '14px', color: '#333' }}>{templateAtivo.template_language}</div>
                </div>
                <div>
                  <span style={{ fontSize: '12px', color: '#999' }}>Header</span>
                  <div style={{ fontSize: '14px', color: '#333' }}>{templateAtivo.template_header_type || 'NONE'}</div>
                </div>
              </div>
              {/* Variáveis mapeadas */}
              {templateAtivo.template_variables && (() => {
                const mappedVars = templateAtivo.template_variables.split(',').map(v => v.trim());
                return (
                  <div style={{ marginBottom: '16px' }}>
                    <span style={{ fontSize: '12px', color: '#999', display: 'block', marginBottom: '6px' }}>Variáveis Mapeadas</span>
                    {mappedVars.map((v, i) => {
                      const info = variaveisDisponiveis.find(o => o.value === v);
                      const exData = previewExampleData || {};
                      const fallback = info?.example || v;
                      const exValue = exData[v] || fallback;
                      return (
                        <div key={i} style={{
                          display: 'flex', gap: '8px', alignItems: 'center',
                          padding: '6px 10px', marginBottom: '4px',
                          background: '#e3f2fd', borderRadius: '6px', fontSize: '13px',
                        }}>
                          <span style={{ fontWeight: '600', color: '#1565c0' }}>{`{{${i + 1}}}`}</span>
                          <span style={{ color: '#333' }}>{info?.label || v}</span>
                          <span style={{ color: '#888', marginLeft: 'auto', fontSize: '11px', maxWidth: '180px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {(exValue || '').split('\n')[0]}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                );
              })()}
              {previewExampleData && (
                <div style={{ fontSize: '11px', color: '#888', padding: '6px 10px', background: '#f5f5f5', borderRadius: '6px' }}>
                  Exemplo com dados de: <strong>{previewExampleData.nome_paciente}</strong> - Protocolo {previewExampleData.protocolo}
                </div>
              )}
            </div>
            {/* Preview do celular */}
            {(() => {
              const tmpl = templates.find(t => t.name === templateAtivo.template_name);
              if (!tmpl) return (
                <div style={{ flex: '0 0 auto', textAlign: 'center' }}>
                  <div style={{ fontSize: '12px', color: '#999', marginBottom: '8px' }}>
                    Sincronize os templates para ver o preview
                  </div>
                </div>
              );
              const mappedVars = (templateAtivo.template_variables || '').split(',').map(v => v.trim()).filter(Boolean);
              const exData = previewExampleData || {};
              const fallbackEx = {};
              variaveisDisponiveis.forEach(v => { fallbackEx[v.value] = v.example; });
              const bodyComp = tmpl.components?.find(c => c.type === 'BODY');
              const vars = (bodyComp?.text || '').match(/\{\{\d+\}\}/g) || [];
              const exValues = vars.map((_, idx) => {
                const mapped = mappedVars[idx];
                if (!mapped) return `[variável ${idx + 1}]`;
                return exData[mapped] || fallbackEx[mapped] || mapped;
              });
              return (
                <div style={{ flex: '0 0 auto' }}>
                  <div style={{ fontSize: '11px', color: '#888', textAlign: 'center', marginBottom: '6px' }}>
                    Como o paciente recebe
                  </div>
                  {renderPhonePreview(tmpl, exValues)}
                </div>
              );
            })()}
          </div>
        ) : (
          <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>
            Nenhum template selecionado. Busque os templates da sua conta e selecione um.
          </p>
        )}
      </CollapsibleSection>

      {/* Imagem do Cabeçalho */}
      <CollapsibleSection title="Imagem do Cabecalho" defaultOpen={false} borderColor="#f57c00">
        {(!templateAtivo.template_name || templateAtivo.template_header_type !== 'IMAGE') ? (
          <p style={{ fontSize: '13px', color: '#888', margin: 0 }}>
            {!templateAtivo.template_name
              ? 'Selecione um template ativo para configurar a imagem do cabeçalho.'
              : `O template "${templateAtivo.template_name}" não usa imagem no cabeçalho.`
            }
            {' '}O template <strong>seu_exame_</strong> usa imagem.
          </p>
        ) : (() => {
          return (
            <div>
              <p style={{ fontSize: '13px', color: '#666', marginTop: 0, marginBottom: '12px' }}>
                O template <strong>{templateAtivo.template_name}</strong> usa uma imagem no cabeçalho.
                {' '}Envie uma imagem PNG ou JPG (recomendado 800x418px).
                {' '}Imagens maiores que 1MB serão comprimidas automaticamente.
              </p>

              {headerImageUrl ? (
                <div>
                  <div style={{ marginBottom: '12px', position: 'relative', display: 'inline-block' }}>
                    <img src={headerImageUrl} alt="Header"
                      style={{ maxWidth: '400px', maxHeight: '210px', borderRadius: '8px', border: '1px solid #e0e0e0', display: 'block' }} />
                  </div>
                  <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                    <label style={{
                      ...btnSecondary, display: 'inline-flex', alignItems: 'center', gap: '6px', cursor: 'pointer',
                      opacity: uploadingHeaderImage ? 0.7 : 1,
                    }}>
                      Trocar imagem
                      <input type="file" accept="image/png,image/jpeg,image/jpg"
                        style={{ display: 'none' }} onChange={handleHeaderImageUpload}
                        disabled={uploadingHeaderImage} />
                    </label>
                    <button type="button" style={btnDanger} onClick={removerHeaderImage}>
                      Remover
                    </button>
                    {uploadingHeaderImage && <span style={{ fontSize: '13px', color: '#666' }}>Comprimindo e enviando...</span>}
                  </div>
                </div>
              ) : (
                <div>
                  <label style={{
                    display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                    padding: '32px 24px', border: '2px dashed #d1d5db', borderRadius: '8px',
                    cursor: uploadingHeaderImage ? 'wait' : 'pointer', transition: 'all 0.2s',
                    backgroundColor: '#fafafa',
                  }}
                    onDragOver={(e) => { e.preventDefault(); e.currentTarget.style.borderColor = '#f57c00'; e.currentTarget.style.backgroundColor = '#fff8e1'; }}
                    onDragLeave={(e) => { e.currentTarget.style.borderColor = '#d1d5db'; e.currentTarget.style.backgroundColor = '#fafafa'; }}
                    onDrop={(e) => {
                      e.preventDefault();
                      e.currentTarget.style.borderColor = '#d1d5db';
                      e.currentTarget.style.backgroundColor = '#fafafa';
                      const file = e.dataTransfer.files?.[0];
                      if (file) handleHeaderImageUpload({ target: { files: [file], value: '' } });
                    }}
                  >
                    <div style={{ fontSize: '32px', marginBottom: '8px', color: '#9ca3af' }}>&#128247;</div>
                    <div style={{ fontSize: '14px', fontWeight: '500', color: '#4b5563', marginBottom: '4px' }}>
                      {uploadingHeaderImage ? 'Comprimindo e enviando...' : 'Clique ou arraste uma imagem'}
                    </div>
                    <div style={{ fontSize: '12px', color: '#9ca3af' }}>
                      PNG ou JPG, recomendado 800x418px
                    </div>
                    <input type="file" accept="image/png,image/jpeg,image/jpg"
                      style={{ display: 'none' }} onChange={handleHeaderImageUpload}
                      disabled={uploadingHeaderImage} />
                  </label>
                </div>
              )}

              {headerImageError && (
                <div style={{ marginTop: '8px', padding: '8px 12px', borderRadius: '6px', fontSize: '13px', backgroundColor: '#ffebee', color: '#c62828', border: '1px solid #ffcdd2' }}>
                  {headerImageError}
                </div>
              )}
            </div>
          );
        })()}
      </CollapsibleSection>

      {/* Templates da Conta Meta */}
      <CollapsibleSection title="Templates da Conta Meta" defaultOpen={false}
        badge={{ text: `${templates.length}`, bg: '#f5f5f5', color: '#666' }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <button type="button" style={{
            ...btnSecondary, display: 'flex', alignItems: 'center', gap: '6px',
          }} onClick={() => buscarTemplates()} disabled={loadingTemplates}>
            {loadingTemplates ? 'Sincronizando...' : 'Sincronizar com Meta'}
          </button>
          <button type="button" style={btnPrimary} onClick={() => setShowCreateForm(!showCreateForm)}>
            {showCreateForm ? 'Cancelar' : '+ Criar Novo'}
          </button>
        </div>

        {/* Filtros */}
        <div className="responsive-flex" style={{ display: 'flex', gap: '12px', marginBottom: '16px', flexWrap: 'wrap' }}>
          <input type="text" style={{ ...inputStyle, maxWidth: '260px' }}
            placeholder="Buscar por nome ou conteúdo..."
            value={templateFilter} onChange={(e) => setTemplateFilter(e.target.value)}
            onKeyDown={(e) => e.key === 'Enter' && buscarTemplates()} />
          <select style={{ ...selectStyle, maxWidth: '180px' }}
            value={templateStatusFilter} onChange={(e) => setTemplateStatusFilter(e.target.value)}>
            <option value="">Todos os status</option>
            <option value="APPROVED">Aprovado</option>
            <option value="PENDING">Pendente</option>
            <option value="REJECTED">Rejeitado</option>
          </select>
          <select style={{ ...selectStyle, maxWidth: '180px' }}
            value={templateCategoryFilter} onChange={(e) => setTemplateCategoryFilter(e.target.value)}>
            <option value="">Todas categorias</option>
            <option value="UTILITY">Utilidade</option>
            <option value="MARKETING">Marketing</option>
            <option value="AUTHENTICATION">Autenticação</option>
          </select>
        </div>

        {/* Formulário de criação */}
        {showCreateForm && (
          <div style={{
            backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
            padding: '24px', marginBottom: '20px',
          }}>
            <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
              Criar Novo Template
            </h4>

            <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div>
                <label style={labelStyle}>Nome *</label>
                <input type="text" style={inputStyle} value={newTemplate.name}
                  onChange={(e) => setNewTemplate({ ...newTemplate, name: e.target.value.toLowerCase().replace(/[^a-z0-9_]/g, '') })}
                  placeholder="resultado_exame" />
                <p style={helpTextStyle}>Lowercase, letras, números e _</p>
              </div>
              <div>
                <label style={labelStyle}>Categoria *</label>
                <select style={selectStyle} value={newTemplate.category}
                  onChange={(e) => setNewTemplate({ ...newTemplate, category: e.target.value })}>
                  <option value="UTILITY">Utilidade</option>
                  <option value="MARKETING">Marketing</option>
                  <option value="AUTHENTICATION">Autenticação</option>
                </select>
              </div>
              <div>
                <label style={labelStyle}>Idioma *</label>
                <select style={selectStyle} value={newTemplate.language}
                  onChange={(e) => setNewTemplate({ ...newTemplate, language: e.target.value })}>
                  <option value="pt_BR">Português (Brasil)</option>
                  <option value="en_US">English (US)</option>
                  <option value="es">Español</option>
                </select>
              </div>
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Tipo de Cabeçalho</label>
              <div className="responsive-flex" style={{ display: 'flex', gap: '12px', marginBottom: '12px' }}>
                {[
                  { value: 'TEXT', label: 'Texto', desc: 'Cabeçalho com texto simples' },
                  { value: 'DOCUMENT', label: 'Documento (PDF)', desc: 'Envia um PDF anexo no cabeçalho' },
                  { value: 'NONE', label: 'Nenhum', desc: 'Sem cabeçalho' },
                ].map(opt => (
                  <label key={opt.value} style={{
                    flex: 1, padding: '12px', borderRadius: '6px', cursor: 'pointer',
                    border: `2px solid ${newTemplate.header_type === opt.value ? '#1976d2' : '#e0e0e0'}`,
                    backgroundColor: newTemplate.header_type === opt.value ? '#e3f2fd' : '#fff',
                    transition: 'all 0.2s ease',
                  }}>
                    <input type="radio" name="header_type" value={opt.value}
                      checked={newTemplate.header_type === opt.value}
                      onChange={(e) => setNewTemplate({ ...newTemplate, header_type: e.target.value, header_text: '', header_file: null })}
                      style={{ display: 'none' }} />
                    <div style={{ fontWeight: '600', fontSize: '13px', color: newTemplate.header_type === opt.value ? '#1976d2' : '#333' }}>
                      {opt.label}
                    </div>
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '2px' }}>{opt.desc}</div>
                  </label>
                ))}
              </div>

              {newTemplate.header_type === 'TEXT' && (
                <div>
                  <label style={labelStyle}>Texto do Cabeçalho</label>
                  <input type="text" style={inputStyle} value={newTemplate.header_text}
                    onChange={(e) => setNewTemplate({ ...newTemplate, header_text: e.target.value })}
                    placeholder="Ex: Resultado de Exame" />
                </div>
              )}

              {newTemplate.header_type === 'DOCUMENT' && (
                <div>
                  <label style={labelStyle}>PDF de Exemplo (obrigatório pela Meta)</label>
                  <input type="file" accept=".pdf,application/pdf"
                    style={{ ...inputStyle, padding: '8px' }}
                    onChange={(e) => setNewTemplate({ ...newTemplate, header_file: e.target.files[0] || null })} />
                  <p style={helpTextStyle}>
                    Envie qualquer PDF de exemplo. A Meta exige um documento de amostra para aprovar o template.
                    Na hora do envio, o PDF real do laudo será usado no lugar.
                  </p>
                  {newTemplate.header_file && (
                    <div style={{ marginTop: '8px', padding: '8px 12px', backgroundColor: '#e8f5e9', borderRadius: '6px', fontSize: '13px', color: '#2e7d32' }}>
                      Arquivo selecionado: {newTemplate.header_file.name} ({(newTemplate.header_file.size / 1024).toFixed(1)} KB)
                    </div>
                  )}
                </div>
              )}
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Corpo da Mensagem *</label>
              <textarea style={{ ...inputStyle, minHeight: '100px', resize: 'vertical', fontFamily: 'inherit' }}
                value={newTemplate.body_text}
                onChange={(e) => handleBodyTextChange(e.target.value)}
                placeholder={'Olá {{1}}, seus exames do protocolo {{2}} de {{3}} já estão prontos!\n\nAcesse os resultados no site do {{4}}.'} />
              <p style={helpTextStyle}>
                Use {'{{1}}'}, {'{{2}}'}, etc. para variáveis. Informe os valores de exemplo abaixo.
              </p>
            </div>

            {/* Valores de exemplo dinâmicos */}
            {(newTemplate.body_text.match(/\{\{\d+\}\}/g) || []).length > 0 && (
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Valores de Exemplo (obrigatórios para variáveis)</label>
                <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
                  {(newTemplate.body_text.match(/\{\{\d+\}\}/g) || []).map((v, idx) => (
                    <div key={idx}>
                      <input type="text" style={inputStyle}
                        placeholder={`Exemplo para ${v}`}
                        value={newTemplate.example_values[idx] || ''}
                        onChange={(e) => {
                          const vals = [...newTemplate.example_values];
                          vals[idx] = e.target.value;
                          setNewTemplate({ ...newTemplate, example_values: vals });
                        }} />
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Rodapé (opcional)</label>
              <input type="text" style={inputStyle} value={newTemplate.footer_text}
                onChange={(e) => setNewTemplate({ ...newTemplate, footer_text: e.target.value })}
                placeholder="Ex: Laboratório Santa Rita" />
            </div>

            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' }}>
              <input type="checkbox" checked={newTemplate.allow_category_change}
                onChange={(e) => setNewTemplate({ ...newTemplate, allow_category_change: e.target.checked })}
                style={{ width: '16px', height: '16px', accentColor: '#1976d2' }} />
              <span style={{ fontSize: '13px', color: '#666' }}>
                Permitir que a Meta altere a categoria se necessário
              </span>
            </div>

            {/* Pré-visualização smartphone */}
            {newTemplate.body_text && (
              <div style={{ marginBottom: '16px' }}>
                <label style={{ ...labelStyle, marginBottom: '10px' }}>Pré-visualização no WhatsApp:</label>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                  {renderPhonePreview({
                    components: [
                      ...(newTemplate.header_type === 'TEXT' && newTemplate.header_text
                        ? [{ type: 'HEADER', format: 'TEXT', text: newTemplate.header_text }]
                        : newTemplate.header_type === 'DOCUMENT'
                          ? [{ type: 'HEADER', format: 'DOCUMENT' }]
                          : []),
                      { type: 'BODY', text: newTemplate.body_text },
                      ...(newTemplate.footer_text ? [{ type: 'FOOTER', text: newTemplate.footer_text }] : []),
                    ]
                  }, newTemplate.example_values)}
                </div>
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" style={{ ...btnPrimary, opacity: creatingTemplate ? 0.7 : 1 }}
                onClick={criarTemplate} disabled={creatingTemplate}>
                {uploadingFile ? 'Enviando arquivo...' : creatingTemplate ? 'Criando...' : 'Criar Template'}
              </button>
              <button type="button" style={btnSecondary} onClick={() => setShowCreateForm(false)}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tabela de templates */}
        {templates.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Tipo</th>
                  <th style={thStyle}>Categoria</th>
                  <th style={thStyle}>Status</th>
                  <th style={thStyle}>Qualidade</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {templates.map((tmpl, idx) => (
                  <tr key={`${tmpl.name}-${tmpl.language}-${idx}`}
                    style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ ...tdStyle, fontWeight: '500' }}>
                      {tmpl.name}
                      {tmpl.name === templateAtivo.template_name && (
                        <span style={{
                          marginLeft: '8px', padding: '2px 8px', borderRadius: '10px',
                          fontSize: '11px', backgroundColor: '#e3f2fd', color: '#1976d2', fontWeight: '600',
                        }}>
                          ATIVO
                        </span>
                      )}
                    </td>
                    <td style={tdStyle}>
                      {(() => {
                        const header = tmpl.components?.find(c => c.type === 'HEADER');
                        if (header?.format === 'DOCUMENT') return (
                          <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                            PDF
                          </span>
                        );
                        return <span style={{ fontSize: '13px', color: '#999' }}>Texto</span>;
                      })()}
                    </td>
                    <td style={tdStyle}>{getCategoryLabel(tmpl.category)}</td>
                    <td style={tdStyle}>{getStatusBadge(tmpl.status)}</td>
                    <td style={tdStyle}>
                      {tmpl.quality_score ? (
                        <span style={{ fontSize: '13px', color: tmpl.quality_score.score === 'GREEN' ? '#2e7d32' : '#f57f17' }}>
                          {tmpl.quality_score.score === 'GREEN' ? 'Alta' : tmpl.quality_score.score === 'YELLOW' ? 'Média' : tmpl.quality_score.score || '-'}
                        </span>
                      ) : '-'}
                    </td>
                    <td style={{ ...tdStyle, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <button type="button" style={{ ...btnSecondary, padding: '6px 14px', fontSize: '13px', marginRight: '8px' }}
                        onClick={() => setPreviewTemplate(tmpl)}>
                        Preview
                      </button>
                      {tmpl.status === 'APPROVED' && (
                        <button type="button" style={{ ...btnSuccess, marginRight: '8px' }}
                          onClick={() => abrirModalSelecao(tmpl)}>
                          Usar
                        </button>
                      )}
                      <button type="button" style={{ ...btnDanger, opacity: deletingTemplate === tmpl.name ? 0.7 : 1 }}
                        onClick={() => {
                          if (window.confirm(`Excluir o template "${tmpl.name}"? Esta ação não pode ser desfeita.`)) {
                            excluirTemplate(tmpl.name);
                          }
                        }}
                        disabled={deletingTemplate === tmpl.name}>
                        {deletingTemplate === tmpl.name ? 'Excluindo...' : 'Excluir'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          !loadingTemplates && (
            <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
              <p style={{ fontSize: '14px', margin: 0 }}>
                Clique em "Buscar Templates" para carregar os templates da sua conta Meta.
              </p>
              <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
                Certifique-se de que o WABA ID está configurado na aba "Conexão e API".
              </p>
            </div>
          )
        )}
        {loadingTemplates && (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            Carregando templates...
          </div>
        )}
      </CollapsibleSection>

      {/* Modal de preview smartphone */}
      {previewTemplate && (
        <div style={overlayStyle} onClick={() => setPreviewTemplate(null)}>
          <div style={{
            backgroundColor: 'transparent', display: 'flex', flexDirection: 'column',
            alignItems: 'center', gap: '20px',
          }} onClick={(e) => e.stopPropagation()}>
            {/* Info do template */}
            <div style={{
              backgroundColor: '#fff', borderRadius: '12px', padding: '20px 28px',
              boxShadow: '0 4px 16px rgba(0,0,0,0.2)', maxWidth: '360px', width: '100%',
            }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
                <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>
                  {previewTemplate.name}
                </h3>
                <button type="button" onClick={() => setPreviewTemplate(null)} style={{
                  background: 'none', border: 'none', fontSize: '20px', color: '#999',
                  cursor: 'pointer', padding: '0 4px',
                }}>
                  ✕
                </button>
              </div>
              <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                {getStatusBadge(previewTemplate.status)}
                <span style={{ fontSize: '12px', color: '#666', padding: '3px 0' }}>
                  {getCategoryLabel(previewTemplate.category)} &middot; {previewTemplate.language}
                </span>
                {(() => {
                  const h = previewTemplate.components?.find(c => c.type === 'HEADER');
                  if (h?.format === 'DOCUMENT') return (
                    <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                      PDF
                    </span>
                  );
                  return null;
                })()}
              </div>
            </div>

            {/* Smartphone mockup */}
            {renderPhonePreview(previewTemplate)}

            {/* Ações */}
            <div style={{ display: 'flex', gap: '12px' }}>
              {previewTemplate.status === 'APPROVED' && (
                <button type="button" style={{ ...btnSuccess, padding: '10px 24px' }}
                  onClick={() => { setPreviewTemplate(null); abrirModalSelecao(previewTemplate); }}>
                  Usar este Template
                </button>
              )}
              <button type="button" style={{ ...btnSecondary, padding: '10px 24px' }}
                onClick={() => setPreviewTemplate(null)}>
                Fechar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal de seleção de template / mapeamento de variáveis */}
      {showSelectModal && selectedTemplate && (
        <div style={overlayStyle} onClick={() => setShowSelectModal(false)}>
          <div style={{
            backgroundColor: '#fff', borderRadius: '12px', padding: '32px',
            maxWidth: '960px', width: '95%', maxHeight: '90vh', overflowY: 'auto',
            boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
          }} onClick={(e) => e.stopPropagation()}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '8px' }}>
              Selecionar Template
            </h3>
            <p style={{ fontSize: '14px', color: '#666', marginBottom: '20px' }}>
              Template: <strong>{selectedTemplate.name}</strong> ({selectedTemplate.language})
            </p>

            {(() => {
              const headerComp = selectedTemplate.components?.find(c => c.type === 'HEADER');
              const hasImageHeader = headerComp?.format === 'IMAGE';
              const bodyComp = selectedTemplate.components?.find(c => c.type === 'BODY');
              const bodyText = bodyComp?.text || '';
              const vars = bodyText.match(/\{\{\d+\}\}/g) || [];
              const groups = [...new Set(variaveisDisponiveis.map(o => o.group))];

              // Montar valores de exemplo para o preview baseado no mapeamento
              const exampleData = previewExampleData || {};
              const fallbackExamples = {};
              variaveisDisponiveis.forEach(v => { fallbackExamples[v.value] = v.example; });
              const liveExampleValues = vars.map((_, idx) => {
                const mapped = variableMapping[idx];
                if (!mapped) return `[variável ${idx + 1}]`;
                return exampleData[mapped] || fallbackExamples[mapped] || mapped;
              });

              return (
                <div style={{ display: 'flex', gap: '32px', alignItems: 'flex-start', flexWrap: 'wrap' }}>
                  {/* Coluna esquerda: mapeamento */}
                  <div style={{ flex: '1 1 340px', minWidth: '300px' }}>
                    {vars.length > 0 ? (
                      <div>
                        <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', marginBottom: '12px' }}>
                          Mapear Variáveis
                        </h4>
                        {vars.map((v, idx) => {
                          const selectedVar = variaveisDisponiveis.find(o => o.value === variableMapping[idx]);
                          return (
                            <div key={idx} style={{ marginBottom: '16px' }}>
                              <label style={labelStyle}>{v} - Variável {idx + 1}</label>
                              <select style={selectStyle}
                                value={variableMapping[idx] || ''}
                                onChange={(e) => {
                                  const mapping = [...variableMapping];
                                  mapping[idx] = e.target.value;
                                  setVariableMapping(mapping);
                                }}>
                                <option value="">-- Selecione --</option>
                                {groups.map(g => (
                                  <optgroup key={g} label={`── ${g} ──`}>
                                    {variaveisDisponiveis.filter(o => o.group === g).map(opt => (
                                      <option key={opt.value} value={opt.value}>{opt.label}</option>
                                    ))}
                                  </optgroup>
                                ))}
                              </select>
                              {selectedVar && (
                                <div style={{ fontSize: '12px', color: '#1976d2', marginTop: '4px', padding: '6px 10px', background: '#e3f2fd', borderRadius: '6px', whiteSpace: 'pre-wrap', maxHeight: '80px', overflowY: 'auto' }}>
                                  <strong>{liveExampleValues[idx]}</strong>
                                  <span style={{ color: '#888', marginLeft: '8px' }}>({liveExampleValues[idx].length} chars)</span>
                                </div>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <p style={{ fontSize: '13px', color: '#666' }}>
                        Este template não possui variáveis.
                      </p>
                    )}

                    {previewExampleData && (
                      <div style={{
                        fontSize: '11px', color: '#888', padding: '8px 12px',
                        background: '#f9f9f9', borderRadius: '6px', marginTop: '8px',
                      }}>
                        Dados reais: <strong>{previewExampleData.nome_paciente}</strong> - Protocolo {previewExampleData.protocolo}
                      </div>
                    )}

                    {/* Upload de imagem do header (quando template usa IMAGE) */}
                    {hasImageHeader && (
                      <div style={{
                        marginTop: '20px', padding: '16px', borderRadius: '8px',
                        border: '1px solid #f57c00', backgroundColor: '#fff8e1',
                      }}>
                        <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#e65100', marginTop: 0, marginBottom: '8px' }}>
                          Imagem do Cabeçalho
                        </h4>
                        <p style={{ fontSize: '12px', color: '#666', marginTop: 0, marginBottom: '12px' }}>
                          Este template exige uma imagem. PNG ou JPG, recomendado 800x418px. Imagens grandes serão comprimidas automaticamente.
                        </p>

                        {headerImageUrl ? (
                          <div>
                            <img src={headerImageUrl} alt="Header"
                              style={{ maxWidth: '100%', maxHeight: '120px', borderRadius: '6px', border: '1px solid #e0e0e0', display: 'block', marginBottom: '8px' }} />
                            <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                              <label style={{
                                padding: '6px 14px', fontSize: '12px', fontWeight: '500', color: '#1976d2',
                                backgroundColor: '#fff', border: '1px solid #1976d2', borderRadius: '6px',
                                cursor: uploadingHeaderImage ? 'wait' : 'pointer',
                              }}>
                                Trocar
                                <input type="file" accept="image/png,image/jpeg,image/jpg"
                                  style={{ display: 'none' }} onChange={handleHeaderImageUpload}
                                  disabled={uploadingHeaderImage} />
                              </label>
                              <button type="button" style={btnDanger} onClick={removerHeaderImage}>
                                Remover
                              </button>
                              {uploadingHeaderImage && <span style={{ fontSize: '11px', color: '#666' }}>Enviando...</span>}
                            </div>
                          </div>
                        ) : (
                          <label style={{
                            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
                            padding: '20px 16px', border: '2px dashed #f57c00', borderRadius: '8px',
                            cursor: uploadingHeaderImage ? 'wait' : 'pointer',
                            backgroundColor: '#fffde7', transition: 'all 0.2s',
                          }}>
                            <div style={{ fontSize: '24px', marginBottom: '4px' }}>&#128247;</div>
                            <div style={{ fontSize: '13px', fontWeight: '500', color: '#e65100' }}>
                              {uploadingHeaderImage ? 'Comprimindo e enviando...' : 'Clique para enviar imagem'}
                            </div>
                            <div style={{ fontSize: '11px', color: '#9ca3af', marginTop: '2px' }}>
                              PNG ou JPG
                            </div>
                            <input type="file" accept="image/png,image/jpeg,image/jpg"
                              style={{ display: 'none' }} onChange={handleHeaderImageUpload}
                              disabled={uploadingHeaderImage} />
                          </label>
                        )}

                        {headerImageError && (
                          <div style={{ marginTop: '8px', fontSize: '12px', color: '#c62828' }}>
                            {headerImageError}
                          </div>
                        )}
                      </div>
                    )}

                    <div style={{ display: 'flex', gap: '12px', marginTop: '24px' }}>
                      <button type="button" style={btnSecondary} onClick={() => setShowSelectModal(false)}>
                        Cancelar
                      </button>
                      <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
                        onClick={selecionarTemplate} disabled={loading}>
                        {loading ? 'Salvando...' : 'Confirmar Seleção'}
                      </button>
                    </div>
                  </div>

                  {/* Coluna direita: preview do celular */}
                  <div style={{ flex: '0 0 auto' }}>
                    <div style={{ fontSize: '12px', color: '#888', textAlign: 'center', marginBottom: '8px', fontWeight: '500' }}>
                      Preview com dados reais
                    </div>
                    {renderPhonePreview(selectedTemplate, liveExampleValues)}
                  </div>
                </div>
              );
            })()}
          </div>
        </div>
      )}
    </div>
  );

  const renderMensagensDiretas = () => (
    <div>
      {/* Card do modelo ativo */}
      <div style={{
        ...cardStyle, borderLeft: '4px solid #7b1fa2',
        backgroundColor: msgDiretaModeloAtivo ? '#faf5ff' : '#fff',
      }}>
        <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '12px' }}>
          Modelo Ativo para Envio Direto
        </h3>
        {msgDiretaModeloAtivo ? (
          <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', alignItems: 'center', marginBottom: '12px' }}>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Nome</span>
                <div style={{ fontSize: '15px', fontWeight: '500', color: '#7b1fa2' }}>
                  {msgDiretaModeloAtivo.nome}
                </div>
              </div>
              <div>
                <span style={{ fontSize: '12px', color: '#999' }}>Anexo</span>
                <div style={{ fontSize: '14px', color: '#333' }}>
                  {msgDiretaModeloAtivo.tipo_anexo === 'pdf_resultado' ? 'PDF do Resultado' : 'Nenhum'}
                </div>
              </div>
            </div>
            <div style={{
              backgroundColor: '#f3e5f5', borderRadius: '8px', padding: '16px',
              border: '1px solid #ce93d8',
            }}>
              <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
              <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                dangerouslySetInnerHTML={{
                  __html: (msgDiretaModeloAtivo.mensagem_texto || '')
                    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                    .replace(/\{nome_paciente\}/g, '<strong>João da Silva</strong>')
                    .replace(/\{primeiro_nome\}/g, '<strong>João</strong>')
                    .replace(/\{protocolo\}/g, '<strong>12345</strong>')
                    .replace(/\{data_atendimento\}/g, '12/02/2026')
                    .replace(/\{local_nome\}/g, 'Itapecerica')
                    .replace(/\{protocolo_data\}/g, '12345 de 12/02/2026')
                    .replace(/\{data_protocolo\}/g, '12/02/2026, protocolo 12345')
                    .replace(/\{data_local\}/g, '12/02/2026 na unidade Itapecerica')
                    .replace(/\{info_atendimento\}/g, 'Protocolo 12345 - 12/02/2026')
                    .replace(/\{nome_laboratorio\}/g, config.nome_laboratorio || 'Laboratório Santa Rita')
                    .replace(/\{link_resultado\}/g, 'http://app.lifesys.com.br/laudos/...')
                    .replace(/\{acesse_link\}/g, 'Acesse seus resultados: http://app.lifesys.com.br/laudos/...')
                    .replace(/\{lab_assinatura\}/g, (config.nome_laboratorio || 'Laboratório Santa Rita') + ' - Cuidando da sua saúde!')
                    .replace(/\{status_exames\}/g, 'Todos os seus 3 exame(s) estão prontos!')
                    .replace(/\{lista_exames\}/g, '✅ Hemograma - pronto\n✅ Glicose - pronto\n✅ TSH - pronto')
                    .replace(/\{total_exames\}/g, '3')
                    .replace(/\{exames_prontos\}/g, '3')
                    .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
                    .replace(/_([^_]+)_/g, '<em>$1</em>')
                    .replace(/~([^~]+)~/g, '<s>$1</s>')
                }} />
            </div>
          </div>
        ) : (
          <p style={{ color: '#999', fontSize: '14px', margin: 0 }}>
            Nenhum modelo ativo. Crie um modelo e ative-o para uso no envio direto.
          </p>
        )}
      </div>

      {/* Info box */}
      <div style={avisoStyle}>
        <strong>Como funciona o envio direto (Session Messages):</strong><br />
        1. Envie um <strong>template de abertura</strong> simples (aprovado pela Meta) para iniciar a conversa<br />
        2. Quando o paciente <strong>responder</strong>, a janela de 24h se abre<br />
        3. Dentro da janela, envie <strong>mensagens diretas gratuitas</strong> com resultados e PDF<br />
        Isso economiza custos com templates complexos da Meta.
      </div>

      {/* Barra de ações */}
      <div style={cardStyle}>
        <div className="responsive-flex" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>
            Modelos de Mensagem Direta
          </h3>
          <button type="button" style={{ ...btnPrimary, backgroundColor: '#7b1fa2' }} onClick={abrirNovoMsgDireta}>
            + Criar Novo
          </button>
        </div>

        {/* Formulário criar/editar */}
        {showMsgDiretaForm && (
          <div style={{
            backgroundColor: '#fafafa', border: '1px solid #e0e0e0', borderRadius: '8px',
            padding: '24px', marginBottom: '20px',
          }}>
            <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', marginTop: 0, marginBottom: '16px' }}>
              {editingMsgDireta ? 'Editar Modelo' : 'Criar Novo Modelo'}
            </h4>

            <div className="responsive-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Nome *</label>
                <input type="text" style={inputStyle} value={msgDiretaFormData.nome}
                  onChange={(e) => setMsgDiretaFormData({ ...msgDiretaFormData, nome: e.target.value })}
                  placeholder="Ex: Resultado com Link" />
              </div>
              <div style={fieldGroupStyle}>
                <label style={labelStyle}>Tipo de Anexo</label>
                <select style={selectStyle} value={msgDiretaFormData.tipo_anexo}
                  onChange={(e) => setMsgDiretaFormData({ ...msgDiretaFormData, tipo_anexo: e.target.value })}>
                  <option value="nenhum">Nenhum (apenas texto)</option>
                  <option value="pdf_resultado">PDF do Resultado</option>
                </select>
              </div>
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Descrição</label>
              <input type="text" style={inputStyle} value={msgDiretaFormData.descricao}
                onChange={(e) => setMsgDiretaFormData({ ...msgDiretaFormData, descricao: e.target.value })}
                placeholder="Breve descrição do modelo" />
            </div>

            <div style={fieldGroupStyle}>
              <label style={labelStyle}>Texto da Mensagem *</label>
              <textarea style={{ ...inputStyle, minHeight: '120px', resize: 'vertical', fontFamily: 'inherit' }}
                value={msgDiretaFormData.mensagem_texto}
                onChange={(e) => setMsgDiretaFormData({ ...msgDiretaFormData, mensagem_texto: e.target.value })}
                placeholder="✅ *Resultados Disponíveis*\n\nOlá, *{nome_paciente}*!..." />
              <p style={helpTextStyle}>
                Basicas: {'{nome_paciente}'}, {'{primeiro_nome}'}, {'{protocolo}'}, {'{data_atendimento}'}, {'{local_nome}'}, {'{nome_laboratorio}'}, {'{link_resultado}'}
                <br />Compostas: {'{protocolo_data}'}, {'{data_protocolo}'}, {'{data_local}'}, {'{info_atendimento}'}, {'{acesse_link}'}, {'{lab_assinatura}'}
                <br />Exames: {'{status_exames}'}, {'{total_exames}'}, {'{exames_prontos}'}, {'{lista_exames}'}
                <br />Formatacao WhatsApp: *negrito*, _italico_, ~tachado~
              </p>
            </div>

            {/* Pré-visualização ao vivo */}
            {msgDiretaFormData.mensagem_texto && (
              <div style={{
                backgroundColor: '#f3e5f5', borderRadius: '8px', padding: '16px', marginBottom: '16px',
                border: '1px solid #ce93d8',
              }}>
                <span style={{ fontSize: '12px', color: '#666', fontWeight: '500' }}>Pré-visualização:</span>
                <div style={{ marginTop: '8px', fontSize: '14px', color: '#333', whiteSpace: 'pre-wrap', lineHeight: '1.5' }}
                  dangerouslySetInnerHTML={{
                    __html: msgDiretaFormData.mensagem_texto
                      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                      .replace(/\{nome_paciente\}/g, 'João da Silva')
                      .replace(/\{protocolo\}/g, '12345')
                      .replace(/\{data_atendimento\}/g, '12/02/2026')
                      .replace(/\{nome_laboratorio\}/g, config.nome_laboratorio || 'Laboratório Santa Rita')
                      .replace(/\{link_resultado\}/g, 'http://app.lifesys.com.br/laudos/...')
                      .replace(/\{status_exames\}/g, 'Todos os seus 3 exame(s) estão prontos!')
                      .replace(/\{lista_exames\}/g, '✅ Hemograma - pronto\n✅ Glicose - pronto\n✅ TSH - pronto')
                      .replace(/\{total_exames\}/g, '3')
                      .replace(/\{exames_prontos\}/g, '3')
                      .replace(/\*([^*]+)\*/g, '<strong>$1</strong>')
                      .replace(/_([^_]+)_/g, '<em>$1</em>')
                      .replace(/~([^~]+)~/g, '<s>$1</s>')
                  }} />
              </div>
            )}

            <div style={{ display: 'flex', gap: '12px' }}>
              <button type="button" style={{ ...btnPrimary, backgroundColor: '#7b1fa2', opacity: loading ? 0.7 : 1 }}
                onClick={salvarMsgDiretaModelo} disabled={loading}>
                {loading ? 'Salvando...' : (editingMsgDireta ? 'Salvar Alterações' : 'Criar Modelo')}
              </button>
              <button type="button" style={btnSecondary} onClick={() => { setShowMsgDiretaForm(false); setEditingMsgDireta(null); }}>
                Cancelar
              </button>
            </div>
          </div>
        )}

        {/* Tabela de modelos */}
        {loadingMsgDireta ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            Carregando modelos...
          </div>
        ) : msgDiretaModelos.length > 0 ? (
          <div style={{ overflowX: 'auto' }}>
            <table style={tableStyle}>
              <thead>
                <tr>
                  <th style={thStyle}>Nome</th>
                  <th style={thStyle}>Descrição</th>
                  <th style={thStyle}>Anexo</th>
                  <th style={thStyle}>Status</th>
                  <th style={{ ...thStyle, textAlign: 'right' }}>Ações</th>
                </tr>
              </thead>
              <tbody>
                {msgDiretaModelos.map((modelo, idx) => (
                  <tr key={modelo.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                    <td style={{ ...tdStyle, fontWeight: '500' }}>{modelo.nome}</td>
                    <td style={{ ...tdStyle, color: '#666', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                      {modelo.descricao || '-'}
                    </td>
                    <td style={tdStyle}>
                      {modelo.tipo_anexo === 'pdf_resultado' ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500', backgroundColor: '#fff3e0', color: '#e65100' }}>
                          PDF
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Nenhum</span>
                      )}
                    </td>
                    <td style={tdStyle}>
                      {modelo.ativo ? (
                        <span style={{ padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '600', backgroundColor: '#f3e5f5', color: '#7b1fa2' }}>
                          Ativo
                        </span>
                      ) : (
                        <span style={{ fontSize: '13px', color: '#999' }}>Inativo</span>
                      )}
                    </td>
                    <td style={{ ...tdStyle, textAlign: 'right', whiteSpace: 'nowrap' }}>
                      {!modelo.ativo && (
                        <button type="button" style={{ ...btnSuccess, marginRight: '8px', backgroundColor: '#7b1fa2' }}
                          onClick={() => ativarMsgDiretaModelo(modelo.id)}>
                          Ativar
                        </button>
                      )}
                      <button type="button" style={{ ...btnSecondary, padding: '6px 14px', fontSize: '13px', marginRight: '8px' }}
                        onClick={() => abrirEditarMsgDireta(modelo)}>
                        Editar
                      </button>
                      {!modelo.ativo && (
                        <button type="button" style={btnDanger}
                          onClick={() => {
                            if (window.confirm(`Excluir o modelo "${modelo.nome}"?`)) {
                              excluirMsgDiretaModelo(modelo.id);
                            }
                          }}>
                          Excluir
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>
            <p style={{ fontSize: '14px', margin: 0 }}>Nenhum modelo encontrado.</p>
            <p style={{ fontSize: '12px', marginTop: '8px', color: '#bbb' }}>
              Clique em "Criar Novo" para adicionar um modelo de mensagem direta.
            </p>
          </div>
        )}
      </div>
    </div>
  );

  const getWorkerIndicator = () => {
    if (!workerStatus) return { color: '#9e9e9e', label: 'Carregando...' };
    if (!workerStatus.agendamento_ativo) return { color: '#9e9e9e', label: 'Desativado' };
    if (workerStatus.ultimo_erro) return { color: '#f44336', label: 'Erro' };
    if (!workerStatus.rodando) return { color: '#ff9800', label: 'Parado' };
    if (!workerStatus.dentro_horario) return { color: '#ff9800', label: 'Fora do horario' };
    if (workerStatus.ciclo_em_andamento) return { color: '#1976d2', label: 'Processando...' };
    return { color: '#4caf50', label: 'Rodando' };
  };

  const formatTimeAgo = (isoStr) => {
    if (!isoStr) return '-';
    const diff = (Date.now() - new Date(isoStr).getTime()) / 1000;
    if (diff < 60) return `${Math.round(diff)}s atras`;
    if (diff < 3600) return `${Math.round(diff / 60)}min atras`;
    if (diff < 86400) return `${Math.round(diff / 3600)}h atras`;
    return new Date(isoStr).toLocaleString('pt-BR');
  };

  const formatTimeUntil = (isoStr) => {
    if (!isoStr) return '-';
    const diff = (new Date(isoStr).getTime() - Date.now()) / 1000;
    if (diff <= 0) return 'agora';
    if (diff < 60) return `${Math.round(diff)}s`;
    return `${Math.round(diff / 60)}min`;
  };

  const renderEnvioAutomatico = () => {
    const ind = getWorkerIndicator();
    return (
      <div style={{ ...cardStyle, borderLeft: `4px solid ${ind.color}` }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '20px' }}>
          <h3 style={{ fontSize: '16px', fontWeight: '600', color: '#333', margin: 0 }}>
            Envio Automatico
          </h3>
          <div style={toggleContainerStyle}>
            <button type="button" style={toggleStyle(agendamento.ativo)}
              onClick={() => setAgendamento({ ...agendamento, ativo: !agendamento.ativo })}>
              <div style={toggleKnobStyle(agendamento.ativo)} />
            </button>
            <span style={{ fontSize: '14px', color: '#333', fontWeight: '500' }}>
              {agendamento.ativo ? 'Ativado' : 'Desativado'}
            </span>
          </div>
        </div>

        {/* Status do Worker */}
        {workerStatus && agendamento.ativo && (
          <div style={{
            padding: '12px 16px', borderRadius: '8px', marginBottom: '20px',
            backgroundColor: ind.color === '#4caf50' ? '#e8f5e9' : ind.color === '#ff9800' ? '#fff8e1' : ind.color === '#f44336' ? '#ffebee' : '#f5f5f5',
            border: `1px solid ${ind.color}22`,
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
              <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: ind.color, display: 'inline-block' }} />
              <strong style={{ fontSize: '14px', color: '#333' }}>{ind.label}</strong>
              {workerStatus.ultimo_ciclo && (
                <span style={{ fontSize: '12px', color: '#666' }}>
                  — Ultimo ciclo: {formatTimeAgo(workerStatus.ultimo_ciclo)}
                </span>
              )}
            </div>
            {workerStatus.rodando && workerStatus.proximo_ciclo && (
              <div style={{ fontSize: '12px', color: '#666', marginBottom: '4px' }}>
                Proximo ciclo em: {formatTimeUntil(workerStatus.proximo_ciclo)}
              </div>
            )}
            <div style={{ fontSize: '12px', color: '#666' }}>
              Hoje: {workerStatus.envios_hoje || 0} envios | {workerStatus.reenvios_hoje || 0} reenvios | {workerStatus.erros_hoje || 0} erros | {workerStatus.ciclos_hoje || 0} ciclos
            </div>
            {workerStatus.ultimo_erro && (
              <div style={{ fontSize: '12px', color: '#c62828', marginTop: '4px' }}>
                Ultimo erro: {workerStatus.ultimo_erro}
              </div>
            )}
          </div>
        )}

        {/* Configuracoes */}
        <div className="responsive-flex" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <div style={{ ...fieldGroupStyle, flex: 1, minWidth: '120px', marginBottom: 0 }}>
            <label style={labelStyle}>Intervalo (min)</label>
            <input type="number" style={{ ...inputStyle, maxWidth: '120px' }}
              value={agendamento.intervalo_minutos}
              onChange={(e) => setAgendamento({ ...agendamento, intervalo_minutos: parseInt(e.target.value) || 3 })}
              min="2" max="30" />
          </div>
          <div style={{ ...fieldGroupStyle, flex: 1, minWidth: '120px', marginBottom: 0 }}>
            <label style={labelStyle}>Limite por ciclo</label>
            <input type="number" style={{ ...inputStyle, maxWidth: '120px' }}
              value={agendamento.max_envios_ciclo}
              onChange={(e) => setAgendamento({ ...agendamento, max_envios_ciclo: parseInt(e.target.value) || 20 })}
              min="1" max="100" />
          </div>
        </div>

        <div className="responsive-flex" style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '16px' }}>
          <div style={{ ...fieldGroupStyle, flex: 1, minWidth: '120px', marginBottom: 0 }}>
            <label style={labelStyle}>Horario inicio</label>
            <input type="time" style={{ ...inputStyle, maxWidth: '150px' }}
              value={agendamento.horario_inicio}
              onChange={(e) => setAgendamento({ ...agendamento, horario_inicio: e.target.value })} />
          </div>
          <div style={{ ...fieldGroupStyle, flex: 1, minWidth: '120px', marginBottom: 0 }}>
            <label style={labelStyle}>Horario fim</label>
            <input type="time" style={{ ...inputStyle, maxWidth: '150px' }}
              value={agendamento.horario_fim}
              onChange={(e) => setAgendamento({ ...agendamento, horario_fim: e.target.value })} />
          </div>
        </div>

        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Dias da Semana</label>
          <div style={checkboxGroupStyle}>
            {diasSemana.map((dia) => {
              const checked = agendamento.dias_semana.includes(dia.valor);
              return (
                <label key={dia.valor} style={checkboxLabelStyle(checked)}>
                  <input type="checkbox" checked={checked} onChange={() => toggleDiaSemana(dia.valor)}
                    style={{ display: 'none' }} />
                  {dia.label}
                </label>
              );
            })}
          </div>
        </div>

        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Status Minimo do Exame para Envio</label>
          <select style={{ ...selectStyle, maxWidth: '300px' }} value={agendamento.status_exame}
            onChange={(e) => setAgendamento({ ...agendamento, status_exame: e.target.value })}>
            <option value="P">P - Pendente</option>
            <option value="M">M - Parcial</option>
            <option value="F">F - Falta conferir</option>
            <option value="D">D - Digitado</option>
            <option value="I">I - Impresso</option>
            <option value="E">E - Entregue</option>
          </select>
        </div>

        <div style={{ ...fieldGroupStyle, display: 'flex', alignItems: 'center', gap: '8px' }}>
          <input type="checkbox" id="consentimento" checked={agendamento.apenas_com_consentimento}
            onChange={(e) => setAgendamento({ ...agendamento, apenas_com_consentimento: e.target.checked })}
            style={{ width: '16px', height: '16px', accentColor: '#1976d2', cursor: 'pointer' }} />
          <label htmlFor="consentimento" style={{ fontSize: '14px', color: '#333', cursor: 'pointer' }}>
            Enviar apenas para pacientes com consentimento (PACIENTE.ENVIA_WHATSAPP = T)
          </label>
        </div>

        <div className="responsive-flex" style={{ ...buttonRowStyle, flexWrap: 'wrap' }}>
          <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
            onClick={salvarAgendamento} disabled={loading}>
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
          {agendamento.ativo && (
            <button type="button"
              style={{ ...btnPrimary, backgroundColor: '#2e7d32' }}
              onClick={executarCicloAgora}
              disabled={workerStatus?.ciclo_em_andamento}>
              {workerStatus?.ciclo_em_andamento ? 'Executando...' : 'Executar Agora'}
            </button>
          )}
          <button type="button"
            style={{ padding: '10px 24px', fontSize: '14px', fontWeight: '500', color: '#1976d2', backgroundColor: '#fff', border: '1px solid #1976d2', borderRadius: '6px', cursor: 'pointer' }}
            onClick={carregarHistoricoWorker}>
            Ver Historico
          </button>
        </div>
      </div>
    );
  };

  const renderModoResposta = () => (
    <div>
      <p style={{ ...helpTextStyle, marginBottom: '16px', marginTop: 0 }}>
        Define como o sistema responde quando um paciente envia uma mensagem ou clica em um botao.
      </p>

      {/* Telefone de teste */}
      <div style={{
        padding: '12px 16px', borderRadius: '8px', border: '1px solid #ffa726',
        backgroundColor: '#fff8e1', marginBottom: '16px', display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '14px', fontWeight: '600', color: '#e65100', whiteSpace: 'nowrap' }}>
          <span style={{ fontSize: '16px' }}>&#129514;</span> Modo Teste
        </div>
        <input
          type="text"
          placeholder="Ex: 5537991234567"
          value={config.telefone_teste || ''}
          onChange={(e) => setConfig({ ...config, telefone_teste: e.target.value })}
          style={{
            flex: 1, minWidth: '180px', padding: '8px 12px', border: '1px solid #ffcc80',
            borderRadius: '6px', fontSize: '13px', fontFamily: 'monospace', background: '#fff',
          }}
        />
        <button type="button"
          style={{
            padding: '8px 14px', fontSize: '13px', fontWeight: '500', color: '#fff',
            backgroundColor: config.telefone_teste ? '#e65100' : '#4caf50', border: 'none',
            borderRadius: '6px', cursor: 'pointer', whiteSpace: 'nowrap',
          }}
          onClick={async () => {
            try {
              await axios.put(`${API_URL}/whatsapp/config`, { telefone_teste: config.telefone_teste || '' });
              showMessage(config.telefone_teste ? `Modo teste ativo: apenas ${config.telefone_teste}` : 'Modo teste desativado - agente responde para todos', 'sucesso');
            } catch (e) {
              showMessage('Erro ao salvar telefone de teste', 'erro');
            }
          }}
        >
          {config.telefone_teste ? 'Salvar (Teste Ativo)' : 'Salvar (Todos)'}
        </button>
        <div style={{ width: '100%', fontSize: '11px', color: '#bf360c', marginTop: '-4px' }}>
          {config.telefone_teste
            ? `O agente so responde para ${config.telefone_teste}. Limpe o campo e salve para liberar para todos.`
            : 'Sem restricao - o agente responde para qualquer numero. Insira um telefone para modo teste.'}
        </div>
      </div>

      {['desativado', 'sequencia', 'ia'].map((modo) => {
        const labels = {
          desativado: { titulo: 'Desativado', desc: 'Apenas registra a mensagem, nao responde automaticamente' },
          sequencia: { titulo: 'Sequencia', desc: 'Executa sequencia configurada (botao/keyword) e fallback para IA se habilitada' },
          ia: { titulo: 'Agente IA', desc: 'IA responde diretamente com dados do paciente, sem passar por sequencias' },
        };
        const isSelected = agendamento.modo_resposta === modo;
        return (
          <label key={modo} style={{
            display: 'flex', alignItems: 'flex-start', gap: '10px', padding: '12px 16px',
            borderRadius: '8px', border: `1px solid ${isSelected ? '#1976d2' : '#e0e0e0'}`,
            backgroundColor: isSelected ? '#e3f2fd' : '#fff', cursor: 'pointer', marginBottom: '8px',
            transition: 'all 0.2s ease',
          }}
            onClick={() => setAgendamento({ ...agendamento, modo_resposta: modo })}>
            <input type="radio" name="modo_resposta" checked={isSelected} readOnly
              style={{ width: '18px', height: '18px', accentColor: '#1976d2', marginTop: '2px', cursor: 'pointer' }} />
            <div>
              <div style={{ fontSize: '14px', fontWeight: '600', color: isSelected ? '#1976d2' : '#333' }}>
                {labels[modo].titulo}
              </div>
              <div style={{ fontSize: '12px', color: '#666', marginTop: '2px' }}>
                {labels[modo].desc}
              </div>
            </div>
          </label>
        );
      })}

      <div className="responsive-flex" style={{ display: 'flex', gap: '12px', marginTop: '16px', flexWrap: 'wrap', alignItems: 'center' }}>
        <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
          onClick={salvarAgendamento} disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar'}
        </button>
        <a href="/whatsapp-mensagens" style={{
          padding: '8px 16px', fontSize: '13px', fontWeight: '500', color: '#7b1fa2',
          border: '1px solid #7b1fa2', borderRadius: '6px', textDecoration: 'none', display: 'inline-block',
        }}>
          Configurar Sequencias
        </a>
        <a href="/whatsapp-agente" style={{
          padding: '8px 16px', fontSize: '13px', fontWeight: '500', color: '#1976d2',
          border: '1px solid #1976d2', borderRadius: '6px', textDecoration: 'none', display: 'inline-block',
        }}>
          Configurar Agente IA
        </a>
      </div>
    </div>
  );

  const renderHistoricoModal = () => {
    if (!showHistorico) return null;
    return (
      <div style={overlayStyle} onClick={() => setShowHistorico(false)}>
        <div style={{ ...modalStyle, maxWidth: '700px' }} onClick={(e) => e.stopPropagation()}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
            <h3 style={{ fontSize: '18px', fontWeight: '600', color: '#333', margin: 0 }}>Historico de Ciclos</h3>
            <button onClick={() => setShowHistorico(false)}
              style={{ background: 'none', border: 'none', fontSize: '24px', color: '#999', cursor: 'pointer' }}>x</button>
          </div>

          {workerHistorico.length === 0 ? (
            <div style={{ textAlign: 'center', padding: '40px', color: '#999' }}>Nenhum ciclo registrado ainda.</div>
          ) : (
            <div style={{ overflowX: 'auto', maxHeight: '60vh', overflowY: 'auto' }}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>Inicio</th>
                    <th style={thStyle}>Duracao</th>
                    <th style={thStyle}>Enviados</th>
                    <th style={thStyle}>Reenvios</th>
                    <th style={thStyle}>Erros</th>
                    <th style={thStyle}>Ignorados</th>
                  </tr>
                </thead>
                <tbody>
                  {workerHistorico.map((ciclo, idx) => {
                    const inicio = new Date(ciclo.ciclo_inicio);
                    const fim = ciclo.ciclo_fim ? new Date(ciclo.ciclo_fim) : null;
                    const duracao = fim ? ((fim - inicio) / 1000).toFixed(1) + 's' : '-';
                    return (
                      <tr key={ciclo.id} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                        <td style={tdStyle}>{inicio.toLocaleString('pt-BR')}</td>
                        <td style={tdStyle}>{duracao}</td>
                        <td style={{ ...tdStyle, color: '#2e7d32', fontWeight: '600' }}>{ciclo.total_enviados || 0}</td>
                        <td style={{ ...tdStyle, color: '#1976d2' }}>{ciclo.total_reenvios || 0}</td>
                        <td style={{ ...tdStyle, color: ciclo.total_erros > 0 ? '#c62828' : '#999' }}>{ciclo.total_erros || 0}</td>
                        <td style={{ ...tdStyle, color: '#666' }}>{ciclo.total_ignorados || 0}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    );
  };

  const subSectionStyle = { padding: '16px', borderRadius: '6px', border: '1px solid #eee', backgroundColor: '#fafafa', marginBottom: '16px' };
  const subSectionTitleStyle = { fontSize: '14px', fontWeight: '600', color: '#555', marginTop: 0, marginBottom: '12px' };

  const renderRegrasEnvio = () => (
    <div>
      {/* Politica de envio - a decisao que define quantas mensagens o paciente recebe */}
      <div style={{ ...subSectionStyle, backgroundColor: '#fff' }}>
        <h4 style={subSectionTitleStyle}>Quando avisar o paciente</h4>
        <div className="responsive-flex" style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
          {[
            {
              value: 'agrupado',
              titulo: 'Um aviso por atendimento',
              desc: 'Espera o pedido ficar pronto e manda uma mensagem so. Exame de prazo longo nao segura os outros: nesse caso sai um aviso do que ja esta pronto e outro quando o pedido fecha.',
            },
            {
              value: 'tat',
              titulo: 'A cada exame liberado',
              desc: 'Avisa assim que os exames rapidos ficam prontos e manda uma nova mensagem a cada exame liberado depois. Gera varias mensagens do mesmo atendimento.',
            },
          ].map((op) => {
            const ativo = (regrasEnvio.envio_politica || 'tat') === op.value;
            return (
              <div key={op.value}
                onClick={() => setRegrasEnvio({ ...regrasEnvio, envio_politica: op.value })}
                style={{
                  flex: 1, minWidth: '260px', cursor: 'pointer', padding: '14px', borderRadius: '6px',
                  border: ativo ? '2px solid #1976d2' : '1px solid #ddd',
                  backgroundColor: ativo ? '#e3f2fd' : '#fff',
                }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                  <input type="radio" checked={ativo} readOnly />
                  <strong style={{ fontSize: '14px', color: '#333' }}>{op.titulo}</strong>
                </div>
                <p style={{ ...helpTextStyle, margin: 0 }}>{op.desc}</p>
              </div>
            );
          })}
        </div>

        {regrasEnvio.envio_politica === 'agrupado' && (
          <div className="responsive-flex" style={{ display: 'flex', gap: '16px', marginTop: '14px', flexWrap: 'wrap' }}>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label style={labelStyle}>Esperar no maximo (dias)</label>
              <input type="number" style={{ ...inputStyle, maxWidth: '120px' }}
                value={regrasEnvio.envio_espera_max_dias}
                onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_espera_max_dias: e.target.value })}
                min="1" max="30" />
              <p style={helpTextStyle}>Depois desse prazo o aviso sai mesmo com exame de rotina pendente (exame travado ou refeito nao pode prender o paciente). Padrao: 4 dias.</p>
            </div>
            <div style={{ flex: 1, minWidth: '260px' }}>
              <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer' }}>
                <input type="checkbox"
                  checked={regrasEnvio.envio_esperar_lentos === '1'}
                  onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_esperar_lentos: e.target.checked ? '1' : '0' })} />
                Esperar tambem os exames de prazo longo
              </label>
              <p style={helpTextStyle}>
                Marcado: o paciente recebe UMA mensagem so, quando o pedido inteiro fica pronto (ou quando estoura o prazo acima).
                Desmarcado: avisa o que ja esta pronto e manda a mensagem final quando os exames de apoio chegam.
              </p>
            </div>
            <div style={{ flex: 1, minWidth: '200px' }}>
              <label style={labelStyle}>Maximo de mensagens por atendimento</label>
              <input type="number" style={{ ...inputStyle, maxWidth: '120px' }}
                value={regrasEnvio.envio_max_mensagens}
                onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_max_mensagens: e.target.value })}
                min="1" max="5" />
              <p style={helpTextStyle}>Teto de avisos de resultado do mesmo pedido. Padrao: 2 (o parcial e o final).</p>
            </div>
          </div>
        )}
      </div>

      {/* Delay + Percentual + Dias Retroativos inline */}
      <div className="responsive-flex" style={{ display: 'flex', gap: '16px', marginBottom: '16px', flexWrap: 'wrap' }}>
        <div style={{ ...subSectionStyle, flex: 1, minWidth: '180px', marginBottom: 0 }}>
          <h4 style={subSectionTitleStyle}>Delay de Envio</h4>
          <label style={labelStyle}>Tempo minimo apos digitacao (min)</label>
          <input type="number" style={{ ...inputStyle, maxWidth: '150px' }}
            value={regrasEnvio.envio_delay_minutos}
            onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_delay_minutos: e.target.value })}
            min="0" max="1440" />
          <p style={helpTextStyle}>Espera apos ultimo exame digitado. Padrao: 10 min.</p>
        </div>
        <div style={{ ...subSectionStyle, flex: 1, minWidth: '180px', marginBottom: 0 }}>
          <h4 style={subSectionTitleStyle}>Percentual Minimo</h4>
          <label style={labelStyle}>Exames prontos (%)</label>
          <input type="number" style={{ ...inputStyle, maxWidth: '150px' }}
            value={regrasEnvio.envio_percentual_minimo}
            onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_percentual_minimo: e.target.value })}
            min="0" max="100" />
          <p style={helpTextStyle}>Minimo de exames prontos para enviar. 100% = todos.</p>
        </div>
        <div style={{ ...subSectionStyle, flex: 1, minWidth: '180px', marginBottom: 0 }}>
          <h4 style={subSectionTitleStyle}>Periodo Retroativo</h4>
          <label style={labelStyle}>Buscar exames dos ultimos</label>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <input type="number" style={{ ...inputStyle, maxWidth: '80px' }}
              value={regrasEnvio.dias_retroativos}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, dias_retroativos: e.target.value })}
              min="1" max="60" />
            <span style={{ fontSize: '14px', color: '#666' }}>dias</span>
          </div>
          <p style={helpTextStyle}>Quantos dias atras buscar resultados. Padrao: 14 dias.</p>
        </div>
      </div>

      {/* Data de Corte */}
      <div style={subSectionStyle}>
        <h4 style={subSectionTitleStyle}>Data de Corte para Envios</h4>
        <div style={fieldGroupStyle}>
          <label style={labelStyle}>Enviar apenas exames com data a partir de:</label>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <input type="date" style={{ ...inputStyle, maxWidth: '220px' }}
              value={regrasEnvio.data_corte_envios}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, data_corte_envios: e.target.value })}
            />
            <button type="button" style={{
              padding: '10px 16px', fontSize: '13px', fontWeight: '500', color: '#1976d2',
              backgroundColor: '#e3f2fd', border: '1px solid #bbdefb', borderRadius: '6px', cursor: 'pointer',
              whiteSpace: 'nowrap',
            }}
              onClick={() => setRegrasEnvio({ ...regrasEnvio, data_corte_envios: new Date().toISOString().split('T')[0] })}>
              Hoje
            </button>
            {regrasEnvio.data_corte_envios && (
              <button type="button" style={{
                padding: '10px 16px', fontSize: '13px', fontWeight: '500', color: '#999',
                backgroundColor: '#f5f5f5', border: '1px solid #ddd', borderRadius: '6px', cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
                onClick={() => setRegrasEnvio({ ...regrasEnvio, data_corte_envios: '' })}>
                Limpar
              </button>
            )}
          </div>
          <p style={helpTextStyle}>
            {regrasEnvio.data_corte_envios
              ? `Apenas resultados a partir de ${new Date(regrasEnvio.data_corte_envios + 'T12:00:00').toLocaleDateString('pt-BR')} serao enviados.`
              : `(Padrao: ultimos ${regrasEnvio.dias_retroativos || 14} dias)`}
          </p>
          <div style={{ padding: '10px 14px', background: '#fff8e1', borderRadius: '6px', border: '1px solid #ffe082', marginTop: '8px' }}>
            <p style={{ fontSize: '12px', color: '#f57f17', margin: 0 }}>
              Impede o envio retroativo de resultados antigos. Ao ativar o sistema pela primeira vez, coloque a data de hoje para evitar o envio de ~400 mensagens acumuladas.
            </p>
          </div>
        </div>
      </div>

      {/* Exigir PDF WMI */}
      <div style={subSectionStyle}>
        <h4 style={subSectionTitleStyle}>PDF do Resultado (WMI)</h4>
        <div style={fieldGroupStyle}>
          <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input type="checkbox"
              checked={regrasEnvio.envio_exigir_pdf === '1'}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_exigir_pdf: e.target.checked ? '1' : '0' })}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            Exigir PDF WMI disponivel para enviar
          </label>
          <p style={helpTextStyle}>
            {regrasEnvio.envio_exigir_pdf === '1'
              ? 'O worker so enviara mensagens quando o resultado estiver liberado e o PDF WMI estiver disponivel (RESULTADO_LIBERADO = T + SENHA_SLINE). Protocolos sem PDF serao ignorados.'
              : 'O worker enviara mensagens mesmo sem PDF WMI disponivel. O paciente recebera apenas o link de acesso ao resultado.'}
          </p>

          <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f0fdf4', borderRadius: '6px', border: '1px solid #bbf7d0' }}>
            <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '4px' }}>
              <input type="checkbox"
                checked={regrasEnvio.envio_usar_pdf_interno === '1'}
                onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_usar_pdf_interno: e.target.checked ? '1' : '0' })}
                style={{ width: '18px', height: '18px', cursor: 'pointer' }}
              />
              Usar PDF interno como fallback quando WMI indisponivel
            </label>
            <p style={{ ...helpTextStyle, margin: 0 }}>
              {regrasEnvio.envio_usar_pdf_interno === '1'
                ? 'Quando o PDF WMI nao estiver disponivel, o sistema gerara automaticamente um PDF interno com os resultados do paciente. O envio nao sera bloqueado por falta de PDF WMI.'
                : 'O PDF interno nao sera utilizado. Se o WMI estiver indisponivel, o envio depende da opcao acima (exigir PDF).'}
            </p>
          </div>
        </div>
      </div>

      {/* Exigir Pagamento */}
      <div style={subSectionStyle}>
        <h4 style={subSectionTitleStyle}>Pagamento / Convenio</h4>
        <div style={fieldGroupStyle}>
          <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input type="checkbox"
              checked={regrasEnvio.envio_exigir_pagamento === '1'}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_exigir_pagamento: e.target.checked ? '1' : '0' })}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            Exigir pagamento para enviar resultado (particular)
          </label>
          <p style={helpTextStyle}>
            {regrasEnvio.envio_exigir_pagamento === '1'
              ? 'O worker so enviara para pacientes particulares se o atendimento estiver pago (VALOR_PAGO >= VALOR_COBRADO). Convenios (valor cobrado = 0) sao enviados normalmente.'
              : 'O worker enviara mensagens independente do status de pagamento.'}
          </p>

          {regrasEnvio.envio_exigir_pagamento === '1' && (<>
            <div style={{ marginTop: '12px', padding: '10px 14px', background: '#f0fdf4', borderRadius: '6px', border: '1px solid #bbf7d0' }}>
              <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px' }}>
                Dias retroativos apos pagamento
              </label>
              <input type="number" min="1" max="30"
                value={regrasEnvio.envio_pagamento_dias_retroativos}
                onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_pagamento_dias_retroativos: e.target.value })}
                style={{ padding: '8px 12px', fontSize: '14px', border: '1px solid #ddd', borderRadius: '6px', maxWidth: '100px' }}
              />
              <p style={{ ...helpTextStyle, margin: '4px 0 0' }}>
                Se o paciente pagar depois, o worker voltara ate {regrasEnvio.envio_pagamento_dias_retroativos} dia(s) para enviar o resultado retroativamente. Atendimentos mais antigos que isso nao serao enviados mesmo apos pagamento.
              </p>
            </div>

            <div style={{ marginTop: '12px', padding: '10px 14px', background: '#fff8e1', borderRadius: '6px', border: '1px solid #ffe082' }}>
              <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer', marginBottom: '8px' }}>
                <input type="checkbox"
                  checked={regrasEnvio.envio_notificar_nao_pago === '1'}
                  onChange={(e) => setRegrasEnvio({ ...regrasEnvio, envio_notificar_nao_pago: e.target.checked ? '1' : '0' })}
                  style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                />
                Notificar paciente quando pagamento nao identificado
              </label>
              <p style={{ ...helpTextStyle, margin: '0 0 8px' }}>
                {regrasEnvio.envio_notificar_nao_pago === '1'
                  ? 'Quando os exames estiverem prontos mas o pagamento nao foi registrado, o worker enviara uma mensagem informando o paciente. A notificacao e enviada apenas uma vez por protocolo.'
                  : 'Protocolos nao pagos serao ignorados silenciosamente pelo worker.'}
              </p>
              {regrasEnvio.envio_notificar_nao_pago === '1' && (
                <div>
                  <label style={{ display: 'block', fontSize: '13px', fontWeight: '500', color: '#666', marginBottom: '6px' }}>
                    Mensagem de aviso
                  </label>
                  <textarea
                    value={regrasEnvio.mensagem_nao_pago}
                    onChange={(e) => setRegrasEnvio({ ...regrasEnvio, mensagem_nao_pago: e.target.value })}
                    rows={4}
                    style={{ width: '100%', padding: '10px 12px', fontSize: '13px', border: '1px solid #ddd', borderRadius: '6px', resize: 'vertical', fontFamily: 'inherit', boxSizing: 'border-box' }}
                  />
                  <p style={{ ...helpTextStyle, margin: '4px 0 0' }}>
                    Variaveis disponiveis: {'{primeiro_nome}'}, {'{nome_paciente}'}, {'{protocolo}'}, {'{data_atendimento}'}, {'{local_nome}'}, {'{nome_laboratorio}'}, {'{link_resultado}'}
                  </p>
                </div>
              )}
            </div>
          </>)}
        </div>
      </div>

      {/* Fechar conversa no Chatwoot apos disparo */}
      <div style={subSectionStyle}>
        <h4 style={subSectionTitleStyle}>Conversa no Chatwoot</h4>
        <div style={fieldGroupStyle}>
          <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input type="checkbox"
              checked={regrasEnvio.fechar_conversa_apos_envio === '1'}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, fechar_conversa_apos_envio: e.target.checked ? '1' : '0' })}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            Fechar conversa automaticamente apos enviar o resultado
          </label>
          <p style={helpTextStyle}>
            {regrasEnvio.fechar_conversa_apos_envio === '1'
              ? 'Apos o worker enviar o resultado, a conversa e resolvida (fechada) no Chatwoot — porem APENAS se foi o proprio disparo que a criou/reabriu. Conversas que ja estavam em atendimento (abertas ou pendentes) nao sao tocadas. Se o paciente responder depois, o Chatwoot reabre a conversa automaticamente. Mantem a fila de atendimento limpa.'
              : 'As conversas criadas pelos disparos automaticos permanecem abertas no Chatwoot ate alguem resolve-las manualmente.'}
          </p>
          <div style={{ marginTop: '10px', padding: '10px 14px', background: '#eff6ff', borderRadius: '6px', border: '1px solid #bfdbfe' }}>
            <p style={{ ...helpTextStyle, margin: 0 }}>
              ℹ️ Aplica-se apenas quando o provedor de envio e o <strong>Chatwoot (CRM/FalaVIP)</strong>. Nao afeta a janela de 24h da Meta nem o reenvio de resultados.
              {config.provedor_envio && config.provedor_envio !== 'chatwoot' && (
                <span style={{ display: 'block', marginTop: '6px', color: '#b45309', fontWeight: 500 }}>
                  ⚠️ O provedor atual e "{config.provedor_envio}" — esta opcao nao tera efeito ate que o provedor seja Chatwoot.
                </span>
              )}
            </p>
          </div>
        </div>
      </div>

      {/* Envio Inteligente por TAT */}
      <div style={{ ...subSectionStyle, marginTop: '16px' }}>
        <h4 style={subSectionTitleStyle}>Envio Inteligente por TAT</h4>
        <div style={fieldGroupStyle}>
          <label style={{ ...labelStyle, display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
            <input type="checkbox"
              checked={regrasEnvio.tat_envio_inteligente === '1'}
              onChange={(e) => setRegrasEnvio({ ...regrasEnvio, tat_envio_inteligente: e.target.checked ? '1' : '0' })}
              style={{ width: '18px', height: '18px', cursor: 'pointer' }}
            />
            Ativar envio inteligente baseado em TAT
          </label>
        </div>

        {tatCache && (
          <div style={{ marginTop: '12px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px', flexWrap: 'wrap' }}>
              <span style={{ fontSize: '13px', color: '#666' }}>
                Ultima atualizacao: {tatCache.ultima_atualizacao
                  ? (() => {
                      const d = new Date(tatCache.ultima_atualizacao);
                      const diffDias = Math.floor((new Date() - d) / (1000 * 60 * 60 * 24));
                      return `${d.toLocaleDateString('pt-BR')} (ha ${diffDias} dia${diffDias !== 1 ? 's' : ''})`;
                    })()
                  : 'Nunca'}
              </span>
              <button type="button" style={{
                padding: '6px 14px', fontSize: '12px', fontWeight: '500', color: '#1976d2',
                backgroundColor: '#e3f2fd', border: '1px solid #bbdefb', borderRadius: '6px',
                cursor: loadingTatCache ? 'not-allowed' : 'pointer', opacity: loadingTatCache ? 0.7 : 1,
              }}
                onClick={atualizarTatCache} disabled={loadingTatCache}>
                {loadingTatCache ? 'Atualizando...' : 'Atualizar Cache TAT'}
              </button>
            </div>

            {tatCache.total > 0 && (
              <>
                <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap', marginBottom: '12px' }}>
                  <div style={{ padding: '8px 14px', borderRadius: '6px', backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9', fontSize: '13px', cursor: 'pointer' }}
                    onClick={() => { setShowTatLista(!showTatLista); setTatFiltroCategoria('rapido'); }}>
                    <strong style={{ color: '#2e7d32' }}>Rapido:</strong> <span style={{ color: '#333' }}>{tatCache.resumo?.rapido || 0}</span>
                  </div>
                  <div style={{ padding: '8px 14px', borderRadius: '6px', backgroundColor: '#fff3e0', border: '1px solid #ffe0b2', fontSize: '13px', cursor: 'pointer' }}
                    onClick={() => { setShowTatLista(!showTatLista); setTatFiltroCategoria('medio'); }}>
                    <strong style={{ color: '#e65100' }}>Medio:</strong> <span style={{ color: '#333' }}>{tatCache.resumo?.medio || 0}</span>
                  </div>
                  <div style={{ padding: '8px 14px', borderRadius: '6px', backgroundColor: '#fce4ec', border: '1px solid #f8bbd0', fontSize: '13px', cursor: 'pointer' }}
                    onClick={() => { setShowTatLista(!showTatLista); setTatFiltroCategoria('demorado'); }}>
                    <strong style={{ color: '#c62828' }}>Demorado:</strong> <span style={{ color: '#333' }}>{tatCache.resumo?.demorado || 0}</span>
                  </div>
                  <div style={{ padding: '8px 14px', borderRadius: '6px', backgroundColor: '#f3e5f5', border: '1px solid #e1bee7', fontSize: '13px', cursor: 'pointer' }}
                    onClick={() => { setShowTatLista(!showTatLista); setTatFiltroCategoria('muitoDemorado'); }}>
                    <strong style={{ color: '#6a1b9a' }}>M.Demorado:</strong> <span style={{ color: '#333' }}>{tatCache.resumo?.muitoDemorado || 0}</span>
                  </div>
                </div>

                <div style={{ marginBottom: '12px' }}>
                  <button type="button" style={{
                    padding: '6px 14px', fontSize: '12px', fontWeight: '500', color: '#555',
                    backgroundColor: showTatLista ? '#f0f0f0' : '#fff', border: '1px solid #ddd',
                    borderRadius: '6px', cursor: 'pointer',
                  }}
                    onClick={() => setShowTatLista(!showTatLista)}>
                    {showTatLista ? 'Ocultar lista' : 'Ver lista completa'} ({tatCache.total} exames)
                  </button>
                </div>

                {showTatLista && (
                  <div style={{ marginBottom: '12px' }}>
                    <div className="responsive-flex" style={{ display: 'flex', gap: '10px', marginBottom: '10px', flexWrap: 'wrap', alignItems: 'center' }}>
                      <select style={{ ...inputStyle, maxWidth: '180px', padding: '6px 10px', fontSize: '12px' }}
                        value={tatFiltroCategoria}
                        onChange={(e) => setTatFiltroCategoria(e.target.value)}>
                        <option value="todos">Todas categorias</option>
                        <option value="rapido">Rapido</option>
                        <option value="medio">Medio</option>
                        <option value="demorado">Demorado</option>
                        <option value="muitoDemorado">Muito Demorado</option>
                      </select>
                      <input type="text" style={{ ...inputStyle, maxWidth: '250px', padding: '6px 10px', fontSize: '12px' }}
                        value={tatBusca}
                        onChange={(e) => setTatBusca(e.target.value)}
                        placeholder="Buscar por codigo ou nome..." />
                    </div>
                    <div style={{ overflowX: 'auto', maxHeight: '400px', overflowY: 'auto', border: '1px solid #eee', borderRadius: '6px' }}>
                      <table style={{ ...tableStyle, margin: 0 }}>
                        <thead>
                          <tr>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}>Codigo</th>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1 }}>Descricao</th>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1, textAlign: 'right' }}>Mediana</th>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1, textAlign: 'right' }}>Media</th>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1, textAlign: 'right' }}>Amostras</th>
                            <th style={{ ...thStyle, position: 'sticky', top: 0, backgroundColor: '#f5f5f5', zIndex: 1, textAlign: 'center' }}>Categoria</th>
                          </tr>
                        </thead>
                        <tbody>
                          {(tatCache.exames || [])
                            .filter(e => tatFiltroCategoria === 'todos' || e.categoria === tatFiltroCategoria)
                            .filter(e => !tatBusca || (e.exame_codigo || '').toLowerCase().includes(tatBusca.toLowerCase()) || (e.exame_descricao || '').toLowerCase().includes(tatBusca.toLowerCase()))
                            .map((e, idx) => {
                              const formatTempo = (min) => {
                                if (min < 60) return `${min}min`;
                                if (min < 1440) return `${Math.round(min / 60)}h`;
                                return `${(min / 1440).toFixed(1)}d`;
                              };
                              const catColors = { rapido: { bg: '#e8f5e9', color: '#2e7d32' }, medio: { bg: '#fff3e0', color: '#e65100' }, demorado: { bg: '#fce4ec', color: '#c62828' }, muitoDemorado: { bg: '#f3e5f5', color: '#6a1b9a' } };
                              const catLabels = { rapido: 'Rapido', medio: 'Medio', demorado: 'Demorado', muitoDemorado: 'M.Demorado' };
                              const cc = catColors[e.categoria] || catColors.rapido;
                              return (
                                <tr key={e.exame_codigo} style={{ backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa' }}>
                                  <td style={{ ...tdStyle, fontWeight: '600', fontSize: '12px' }}>{e.exame_codigo}</td>
                                  <td style={{ ...tdStyle, fontSize: '12px', maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{e.exame_descricao}</td>
                                  <td style={{ ...tdStyle, textAlign: 'right', fontSize: '12px', fontWeight: '600' }}>{formatTempo(e.mediana_minutos)}</td>
                                  <td style={{ ...tdStyle, textAlign: 'right', fontSize: '12px', color: '#666' }}>{formatTempo(e.media_minutos)}</td>
                                  <td style={{ ...tdStyle, textAlign: 'right', fontSize: '12px', color: '#666' }}>{e.total_amostras}</td>
                                  <td style={{ ...tdStyle, textAlign: 'center' }}>
                                    <span style={{ fontSize: '11px', padding: '2px 8px', borderRadius: '10px', backgroundColor: cc.bg, color: cc.color, fontWeight: '500' }}>
                                      {catLabels[e.categoria] || e.categoria}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        )}

        <div style={{ padding: '10px 14px', background: '#eff6ff', borderRadius: '6px', border: '1px solid #bfdbfe', marginTop: '8px' }}>
          <p style={{ fontSize: '12px', color: '#1e40af', margin: 0, lineHeight: '1.5' }}>
            <strong>Como funciona:</strong><br />
            Rapidos (ate 24h): 1o envio quando todos prontos.<br />
            Medios (2-3d): reenvio em lote quando todos prontos.<br />
            Demorados (4-7d+): reenvio individual a cada resultado.<br /><br />
            O cache e baseado nos ultimos 90 dias de dados reais. Recomendado atualizar a cada 30 dias.
          </p>
        </div>
      </div>

      {/* Save button */}
      <div className="responsive-flex" style={buttonRowStyle}>
        <button type="button" style={{ ...btnPrimary, opacity: loading ? 0.7 : 1 }}
          onClick={salvarRegrasEnvio} disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar Regras'}
        </button>
      </div>
    </div>
  );

  const renderTemplatesEMensagens = () => (
    <div>
      {/* Templates de Envio */}
      <CollapsibleSection title="Templates de Envio" borderColor="#1976d2">
        {renderTemplate()}
      </CollapsibleSection>

      {/* Mensagens Diretas e Sequências */}
      <div style={{ ...cardStyle, borderLeft: '4px solid #7b1fa2', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <div>
          <h4 style={{ fontSize: '15px', fontWeight: '600', color: '#333', margin: 0, marginBottom: '4px' }}>
            Mensagens Diretas e Sequências
          </h4>
          <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
            Gerencie modelos de mensagem direta e sequências de mensagens automáticas.
          </p>
        </div>
        <a href="/whatsapp-mensagens" style={{ ...btnPrimary, backgroundColor: '#7b1fa2', textDecoration: 'none', whiteSpace: 'nowrap' }}>
          Gerenciar
        </a>
      </div>
    </div>
  );

  const renderWebhookAutoRespostas = () => (
    <div>
      <CollapsibleSection title="URLs do Webhook" defaultOpen={false}>
        <p style={{ fontSize: '13px', color: '#666', marginBottom: '12px' }}>
          Configure estas URLs no sistema externo para receber eventos do WhatsApp:
        </p>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '8px' }}>
          <input
            type="text"
            readOnly
            value={`${window.location.origin.replace(/:\d+$/, ':' + (config.phone_number_id ? '3566' : '3566'))}/api/whatsapp/webhook-receiver`}
            style={{ flex: 1, padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', fontFamily: 'monospace', backgroundColor: '#f9fafb' }}
            onClick={(e) => e.target.select()}
          />
          <button
            onClick={() => {
              const url = `${window.location.origin.replace(/:\d+$/, ':3566')}/api/whatsapp/webhook-receiver`;
              navigator.clipboard.writeText(url);
              showMessage('URL copiada para a área de transferência!', 'success');
            }}
            style={{ padding: '10px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap' }}
          >
            Copiar
          </button>
        </div>

        <div style={{ display: 'flex', gap: '8px', marginBottom: '12px' }}>
          <input
            type="text"
            readOnly
            value={`${window.location.origin.replace(/:\d+$/, ':' + (config.phone_number_id ? '3566' : '3566'))}/api/webhook/whatsapp`}
            style={{ flex: 1, padding: '10px 12px', border: '1px solid #d1d5db', borderRadius: '6px', fontSize: '13px', fontFamily: 'monospace', backgroundColor: '#f9fafb' }}
            onClick={(e) => e.target.select()}
          />
          <button
            onClick={() => {
              const url = `${window.location.origin.replace(/:\d+$/, ':3566')}/api/webhook/whatsapp`;
              navigator.clipboard.writeText(url);
              showMessage('URL copiada para a área de transferência!', 'success');
            }}
            style={{ padding: '10px 16px', background: '#3b82f6', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontSize: '13px', fontWeight: 600, whiteSpace: 'nowrap' }}
          >
            Copiar
          </button>
        </div>

        <p style={{ fontSize: '11px', color: '#9ca3af', margin: 0 }}>
          A primeira URL é para cópia de webhooks (sistema externo). A segunda é para verificação direta da Meta (GET challenge + POST events).
        </p>
      </CollapsibleSection>

      <CollapsibleSection title="Auto-Respostas" defaultOpen={false}>

      <div style={{ padding: '12px 16px', background: '#f0fdf4', borderRadius: '8px', border: '1px solid #bbf7d0', marginBottom: '16px' }}>
        <p style={{ fontSize: '13px', color: '#166534', margin: 0 }}>
          <strong>Botão OK/Confirmação:</strong> Quando um paciente clica no botão de confirmação, o sistema executa a <strong>sequência configurada</strong> (se houver) ou envia a resposta padrão com link de acesso. Configure sequências em <a href="/whatsapp-mensagens" style={{ color: '#166534', fontWeight: 600 }}>WhatsApp &gt; Mensagens</a>.
        </p>
      </div>

      <div style={{ padding: '12px 16px', background: '#faf5ff', borderRadius: '8px', border: '1px solid #e9d5ff', marginBottom: '16px' }}>
        <p style={{ fontSize: '13px', color: '#6b21a8', margin: 0 }}>
          <strong>Palavras-chave:</strong> Mensagens de texto que correspondam a uma palavra-chave configurada disparam automaticamente a sequência associada. Configure em <a href="/whatsapp-mensagens" style={{ color: '#7c3aed', fontWeight: 600 }}>WhatsApp &gt; Mensagens</a>.
        </p>
      </div>

      <div style={{ padding: '12px 16px', background: '#eff6ff', borderRadius: '8px', border: '1px solid #bfdbfe', marginBottom: '16px' }}>
        <p style={{ fontSize: '13px', color: '#1e40af', margin: 0 }}>
          <strong>Agente IA:</strong> Se o Agente IA estiver ativado, mensagens de texto recebidas (que não correspondam a uma palavra-chave) serão respondidas automaticamente pela IA. Configure em <a href="/whatsapp-agente" style={{ color: '#2563eb', fontWeight: 600 }}>WhatsApp &gt; Agente IA</a>.
        </p>
      </div>

      <div style={{ fontSize: '13px', color: '#6b7280' }}>
        <p style={{ marginBottom: '8px' }}><strong>Fluxo de prioridade das respostas automáticas:</strong></p>
        <ol style={{ paddingLeft: '20px', lineHeight: '1.8' }}>
          <li>Botão de confirmação (OK/Sim) → Executa sequência configurada ou envia link padrão</li>
          <li>Texto com palavra-chave → Executa sequência da palavra-chave</li>
          <li>Texto + IA ativada + dentro do horário → Agente IA responde</li>
          <li>Texto + IA ativada + fora do horário → Mensagem de fora de horário</li>
          <li>Outros tipos de mensagem → Apenas registra no sistema</li>
        </ol>
      </div>
      </CollapsibleSection>
    </div>
  );

  const renderRegrasCompletas = () => (
    <div>
      {/* Secao 1: Envio Automatico (worker) */}
      {renderEnvioAutomatico()}

      {/* Secao 2: Regras de envio (delay, percentual, TAT) */}
      <CollapsibleSection title="Regras de Envio" defaultOpen={false}>
        {renderRegrasEnvio()}
      </CollapsibleSection>

      {/* Secao 2.5: Preview dos próximos envios */}
      <CollapsibleSection
        title="Proximos a Serem Enviados"
        badge={proximosEnvios ? { text: `${proximosEnvios.candidatos.length} candidatos`, bg: '#e3f2fd', color: '#1976d2' } : null}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginBottom: '16px', flexWrap: 'wrap', gap: '8px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            {proximosEnvios && (
              <span style={{ fontSize: '13px', color: '#666' }}>
                {proximosEnvios.data_corte && `Corte: ${new Date(proximosEnvios.data_corte + 'T12:00:00').toLocaleDateString('pt-BR')}`}
              </span>
            )}
            <button type="button" style={{
              padding: '8px 16px', fontSize: '13px', fontWeight: '500', color: '#1976d2',
              backgroundColor: '#e3f2fd', border: '1px solid #bbdefb', borderRadius: '6px', cursor: 'pointer',
              opacity: loadingProximos ? 0.6 : 1,
            }}
              onClick={(e) => { e.stopPropagation(); carregarProximosEnvios(); }} disabled={loadingProximos}>
              {loadingProximos ? 'Carregando...' : 'Atualizar'}
            </button>
          </div>
        </div>

        {loadingProximos && !proximosEnvios ? (
          <div style={{ textAlign: 'center', padding: '40px 20px', color: '#999' }}>Carregando preview...</div>
        ) : proximosEnvios && proximosEnvios.candidatos.length > 0 ? (() => {
          // Contadores por status
          const contagem = { todos: proximosEnvios.candidatos.length, pronto: 0, aguardando: 0, ja_enviado: 0, bloqueado: 0 };
          proximosEnvios.candidatos.forEach(c => { if (contagem[c.status] !== undefined) contagem[c.status]++; });

          // Filtrar por status
          const filtradosPorStatus = proximosFiltro === 'todos'
            ? proximosEnvios.candidatos
            : proximosEnvios.candidatos.filter(c => c.status === proximosFiltro);

          // Filtrar por busca (nome ou protocolo)
          const busca = proximosBusca.trim().toLowerCase();
          const filtrados = busca
            ? filtradosPorStatus.filter(c =>
                (c.paciente_nome || '').toLowerCase().includes(busca) ||
                String(c.protocolo).includes(busca) ||
                `${c.local}/${c.protocolo}`.toLowerCase().includes(busca)
              )
            : filtradosPorStatus;

          // Paginacao
          const totalPaginas = Math.ceil(filtrados.length / PROXIMOS_POR_PAGINA);
          const paginaAtual = Math.min(proximosPagina, totalPaginas || 1);
          const inicio = (paginaAtual - 1) * PROXIMOS_POR_PAGINA;
          const paginados = filtrados.slice(inicio, inicio + PROXIMOS_POR_PAGINA);

          const filtroTab = (key, label, cor, count) => (
            <button key={key} type="button" onClick={() => { setProximosFiltro(key); setProximosPagina(1); }} style={{
              padding: '6px 14px', fontSize: '12px', fontWeight: '500', borderRadius: '16px', cursor: 'pointer',
              border: proximosFiltro === key ? `2px solid ${cor}` : '1px solid #e0e0e0',
              backgroundColor: proximosFiltro === key ? (cor + '18') : '#fff',
              color: proximosFiltro === key ? cor : '#666',
              transition: 'all 0.15s ease',
            }}>
              {label} <span style={{ fontWeight: '600' }}>({count})</span>
            </button>
          );

          return (
            <div>
              {/* Filtros por status */}
              <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap', marginBottom: '12px' }}>
                {filtroTab('todos', 'Todos', '#1976d2', contagem.todos)}
                {filtroTab('pronto', 'Pronto', '#4caf50', contagem.pronto)}
                {filtroTab('aguardando', 'Aguardando', '#ff9800', contagem.aguardando)}
                {filtroTab('ja_enviado', 'Ja enviado', '#9e9e9e', contagem.ja_enviado)}
                {filtroTab('bloqueado', 'Bloqueado', '#f44336', contagem.bloqueado)}
              </div>

              {/* Busca */}
              <div style={{ marginBottom: '12px' }}>
                <input type="text" placeholder="Buscar por nome ou protocolo..."
                  value={proximosBusca}
                  onChange={(e) => { setProximosBusca(e.target.value); setProximosPagina(1); }}
                  style={{ ...inputStyle, maxWidth: '350px' }}
                />
              </div>

              {/* Info filtrada */}
              <div style={{ fontSize: '12px', color: '#999', marginBottom: '8px' }}>
                {filtrados.length} resultado{filtrados.length !== 1 ? 's' : ''}
                {busca && ` para "${proximosBusca.trim()}"`}
                {proximosFiltro !== 'todos' && ` (filtro: ${proximosFiltro.replace('_', ' ')})`}
                {totalPaginas > 1 && ` — Pagina ${paginaAtual} de ${totalPaginas}`}
              </div>

              {/* Tabela */}
              <div style={{ overflowX: 'auto' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                  <thead>
                    <tr style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #e0e0e0' }}>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>#</th>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Protocolo</th>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Paciente</th>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Data</th>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Exames</th>
                      <th style={{ padding: '10px 12px', textAlign: 'left', fontWeight: '600', color: '#555' }}>Status</th>
                      <th style={{ padding: '10px 12px', textAlign: 'center', fontWeight: '600', color: '#555' }}></th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginados.map((c, idx) => {
                      const statusCfg = {
                        pronto: { cor: '#4caf50', bg: '#e8f5e9', icon: '\u25CF', label: c.tipo === 'reenvio' ? 'Reenvio' : 'Pronto' },
                        aguardando: { cor: '#ff9800', bg: '#fff8e1', icon: '\u25CB', label: 'Aguard.' },
                        ja_enviado: { cor: '#9e9e9e', bg: '#f5f5f5', icon: '\u2713', label: 'Ja env.' },
                        bloqueado: { cor: '#f44336', bg: '#ffebee', icon: '\u2715', label: 'Bloq.' },
                      }[c.status] || { cor: '#999', bg: '#f5f5f5', icon: '?', label: c.status };

                      const pctWidth = Math.min(c.percentual_prontos, 100);
                      const numGlobal = inicio + idx + 1;

                      return (
                        <tr key={c.solicitacao_id} style={{
                          borderBottom: '1px solid #f0f0f0',
                          backgroundColor: idx % 2 === 0 ? '#fff' : '#fafafa',
                        }}>
                          <td style={{ padding: '10px 12px', color: '#999' }}>{numGlobal}</td>
                          <td style={{ padding: '10px 12px', fontFamily: 'monospace', fontWeight: '500' }}>
                            <a href={`/atendimentos/${c.solicitacao_id}`}
                              style={{ color: '#1976d2', textDecoration: 'none' }}
                              title="Ver resultado/atendimento">
                              {c.local}/{c.protocolo}
                            </a>
                          </td>
                          <td style={{ padding: '10px 12px', maxWidth: '200px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                            {c.paciente_nome}
                          </td>
                          <td style={{ padding: '10px 12px', whiteSpace: 'nowrap' }}>
                            {c.data_atendimento ? new Date(c.data_atendimento).toLocaleDateString('pt-BR') : '-'}
                          </td>
                          <td style={{ padding: '10px 12px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                              <div style={{ flex: 1, minWidth: '60px', height: '6px', backgroundColor: '#e0e0e0', borderRadius: '3px', overflow: 'hidden' }}>
                                <div style={{
                                  width: `${pctWidth}%`, height: '100%', borderRadius: '3px',
                                  backgroundColor: pctWidth === 100 ? '#4caf50' : pctWidth >= 50 ? '#ff9800' : '#f44336',
                                  transition: 'width 0.3s ease',
                                }} />
                              </div>
                              <span style={{ fontSize: '12px', color: '#666', whiteSpace: 'nowrap' }}>
                                {c.exames_prontos}/{c.total_exames} {c.percentual_prontos}%
                              </span>
                            </div>
                          </td>
                          <td style={{ padding: '10px 12px' }}>
                            <span title={c.motivo || ''} style={{
                              display: 'inline-flex', alignItems: 'center', gap: '4px',
                              padding: '3px 10px', borderRadius: '12px', fontSize: '12px', fontWeight: '500',
                              color: statusCfg.cor, backgroundColor: statusCfg.bg, cursor: c.motivo ? 'help' : 'default',
                            }}>
                              {statusCfg.icon} {statusCfg.label}
                            </span>
                          </td>
                          <td style={{ padding: '10px 12px', textAlign: 'center' }}>
                            <a href={`/atendimentos/${c.solicitacao_id}`}
                              style={{
                                display: 'inline-flex', alignItems: 'center', gap: '4px',
                                padding: '4px 10px', borderRadius: '4px', fontSize: '12px',
                                color: '#1976d2', backgroundColor: '#e3f2fd', textDecoration: 'none',
                                border: '1px solid #bbdefb',
                              }}
                              title="Ver resultado/atendimento">
                              Ver
                            </a>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Paginacao */}
              {totalPaginas > 1 && (
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4px', marginTop: '16px', flexWrap: 'wrap' }}>
                  <button type="button" disabled={paginaAtual <= 1} onClick={() => setProximosPagina(1)}
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', cursor: paginaAtual <= 1 ? 'default' : 'pointer', color: paginaAtual <= 1 ? '#ccc' : '#333' }}>
                    &laquo;
                  </button>
                  <button type="button" disabled={paginaAtual <= 1} onClick={() => setProximosPagina(p => Math.max(1, p - 1))}
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', cursor: paginaAtual <= 1 ? 'default' : 'pointer', color: paginaAtual <= 1 ? '#ccc' : '#333' }}>
                    &lsaquo;
                  </button>
                  {Array.from({ length: totalPaginas }, (_, i) => i + 1)
                    .filter(p => p === 1 || p === totalPaginas || Math.abs(p - paginaAtual) <= 2)
                    .reduce((acc, p, i, arr) => {
                      if (i > 0 && p - arr[i - 1] > 1) acc.push('...');
                      acc.push(p);
                      return acc;
                    }, [])
                    .map((p, i) => typeof p === 'string' ? (
                      <span key={`dots-${i}`} style={{ padding: '6px 4px', fontSize: '12px', color: '#999' }}>{p}</span>
                    ) : (
                      <button key={p} type="button" onClick={() => setProximosPagina(p)}
                        style={{
                          padding: '6px 10px', fontSize: '12px', border: '1px solid', borderRadius: '4px', cursor: 'pointer',
                          borderColor: p === paginaAtual ? '#1976d2' : '#ddd',
                          backgroundColor: p === paginaAtual ? '#1976d2' : '#fff',
                          color: p === paginaAtual ? '#fff' : '#333',
                          fontWeight: p === paginaAtual ? '600' : '400',
                        }}>
                        {p}
                      </button>
                    ))
                  }
                  <button type="button" disabled={paginaAtual >= totalPaginas} onClick={() => setProximosPagina(p => Math.min(totalPaginas, p + 1))}
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', cursor: paginaAtual >= totalPaginas ? 'default' : 'pointer', color: paginaAtual >= totalPaginas ? '#ccc' : '#333' }}>
                    &rsaquo;
                  </button>
                  <button type="button" disabled={paginaAtual >= totalPaginas} onClick={() => setProximosPagina(totalPaginas)}
                    style={{ padding: '6px 10px', fontSize: '12px', border: '1px solid #ddd', borderRadius: '4px', backgroundColor: '#fff', cursor: paginaAtual >= totalPaginas ? 'default' : 'pointer', color: paginaAtual >= totalPaginas ? '#ccc' : '#333' }}>
                    &raquo;
                  </button>
                </div>
              )}

              {/* Legenda */}
              <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginTop: '16px', paddingTop: '12px', borderTop: '1px solid #f0f0f0' }}>
                <span style={{ fontSize: '11px', color: '#4caf50' }}>{'\u25CF'} Pronto (sera enviado)</span>
                <span style={{ fontSize: '11px', color: '#ff9800' }}>{'\u25CB'} Aguardando</span>
                <span style={{ fontSize: '11px', color: '#9e9e9e' }}>{'\u2713'} Ja enviado</span>
                <span style={{ fontSize: '11px', color: '#f44336' }}>{'\u2715'} Bloqueado</span>
              </div>
            </div>
          );
        })() : proximosEnvios ? (
          <div style={{ textAlign: 'center', padding: '30px 20px', color: '#999' }}>
            Nenhum candidato encontrado para envio.
          </div>
        ) : null}
      </CollapsibleSection>

      {/* Secao 3: Modo de Resposta */}
      <CollapsibleSection title="Respostas" defaultOpen={false}>
        {renderModoResposta()}
      </CollapsibleSection>

      {/* Botão Salvar Tudo */}
      <div style={{
        marginTop: '32px', padding: '20px 24px', backgroundColor: '#fff', borderRadius: '8px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)', display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        flexWrap: 'wrap', gap: '12px',
      }}>
        <p style={{ fontSize: '13px', color: '#666', margin: 0 }}>
          Alterou varias configuracoes? Salve tudo de uma vez.
        </p>
        <button type="button" style={{ ...btnPrimary, padding: '12px 32px', fontSize: '15px', opacity: loading ? 0.7 : 1 }}
          onClick={salvarTudo} disabled={loading}>
          {loading ? 'Salvando...' : 'Salvar Todas as Alteracoes'}
        </button>
      </div>

      {/* Modal Historico */}
      {renderHistoricoModal()}
    </div>
  );

  const docSectionStyle = { marginBottom: '16px' };
  const docTextStyle = { fontSize: '14px', lineHeight: '1.7', color: '#444', margin: '0 0 12px 0' };
  const docListStyle = { fontSize: '14px', lineHeight: '1.8', color: '#444', margin: '0 0 12px 0', paddingLeft: '20px' };
  const docCodeStyle = { fontFamily: 'monospace', fontSize: '13px', backgroundColor: '#f5f5f5', padding: '2px 6px', borderRadius: '3px', color: '#c62828' };
  const docTableStyle = { width: '100%', borderCollapse: 'collapse', fontSize: '13px', marginBottom: '16px' };
  const docThStyle = { textAlign: 'left', padding: '10px 12px', backgroundColor: '#f5f5f5', borderBottom: '2px solid #ddd', fontWeight: '600', color: '#333' };
  const docTdStyle = { padding: '8px 12px', borderBottom: '1px solid #eee', color: '#444' };
  const docHighlightStyle = { padding: '14px 18px', borderRadius: '6px', marginBottom: '16px', fontSize: '13px', lineHeight: '1.7' };

  const renderComoFunciona = () => (
    <div>
      <CollapsibleSection title="Visao Geral do Sistema" defaultOpen={true} borderColor="#1976d2">
        <div style={docSectionStyle}>
          <p style={docTextStyle}>
            O sistema de envio automatico de WhatsApp monitora continuamente os resultados de exames no banco de dados
            (SQL Server) e envia notificacoes aos pacientes quando seus resultados ficam prontos.
          </p>
          <div style={{ ...docHighlightStyle, backgroundColor: '#e3f2fd', border: '1px solid #bbdefb' }}>
            <strong>Fluxo resumido:</strong><br />
            Paciente faz exames &#8594; Laboratorio digita resultados &#8594; Worker detecta resultados prontos &#8594;
            Envia WhatsApp automatico &#8594; Registra snapshot &#8594; Monitora novos exames para reenvio
          </div>
          <p style={docTextStyle}>
            O worker roda em ciclos periodicos (configuravel em minutos). Cada ciclo:
          </p>
          <ol style={docListStyle}>
            <li>Verifica se esta dentro do horario e dia permitidos</li>
            <li>Consulta solicitacoes dos ultimos <strong>N dias</strong> (Periodo Retroativo) que tenham telefone</li>
            <li>Para cada solicitacao, avalia se esta pronta para envio</li>
            <li>Envia via provedor configurado (WAHA ou Meta Business API)</li>
            <li>Registra o envio com um <em>snapshot</em> completo dos exames naquele momento</li>
          </ol>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Como o Worker Monitora os Exames" defaultOpen={false} borderColor="#388e3c">
        <div style={docSectionStyle}>
          <p style={docTextStyle}>
            O worker nao recebe "eventos" quando um exame fica pronto. Ele funciona por <strong>polling</strong>:
            a cada ciclo, consulta o SQL Server e compara o estado atual com o que ja foi enviado.
          </p>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Snapshot de Exames</h4>
          <p style={docTextStyle}>
            Para cada solicitacao, o sistema tira uma "foto" (snapshot) de todos os exames, contendo:
          </p>
          <ul style={docListStyle}>
            <li><strong>Codigo e nome</strong> de cada exame</li>
            <li><strong>Situacao</strong> atual (Pendente, Digitado, Impresso, etc.)</li>
            <li><strong>Data/hora da digitacao</strong> (DATA_HORA_DIG)</li>
            <li>Se tem resultado e/ou PDF disponivel</li>
            <li>Categoria TAT do exame (rapido, medio, demorado) — quando envio inteligente esta ativo</li>
          </ul>
          <p style={docTextStyle}>
            Esse snapshot e salvo no PostgreSQL (tabela <span style={docCodeStyle}>whatsapp_envios</span>) junto com cada envio.
            Quando o worker roda novamente, ele compara o snapshot atual com o anterior para detectar mudancas.
          </p>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Status dos Exames (SITUACAO)</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Codigo</th>
                <th style={docThStyle}>Descricao</th>
                <th style={docThStyle}>Considerado Pronto?</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['P', 'Pendente', 'Nao'],
                ['M', 'Parcial', 'Nao'],
                ['D', 'Digitado', 'Sim (se status minimo = D)'],
                ['F', 'Falta conferir', 'Sim (se status minimo = F)'],
                ['L', 'Liberado', 'Sim'],
                ['I', 'Impresso (padrao)', 'Sim'],
                ['E', 'Entregue', 'Sim'],
                ['A', 'Assinado', 'Sim'],
              ].map(([cod, desc, pronto], i) => (
                <tr key={cod} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontWeight: '600', fontFamily: 'monospace' }}>{cod}</td>
                  <td style={docTdStyle}>{desc}</td>
                  <td style={docTdStyle}>{pronto}</td>
                </tr>
              ))}
            </tbody>
          </table>
          <div style={{ ...docHighlightStyle, backgroundColor: '#e8f5e9', border: '1px solid #c8e6c9' }}>
            <strong>Status minimo configuravel:</strong> Se voce configurar o status minimo como "D" (Digitado),
            todos os exames com situacao D, F, L, I, E ou A serao considerados prontos.
            Se configurar como "I" (Impresso, padrao), apenas I, E e A contam.
          </div>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Regras de Envio (Readiness Check)" defaultOpen={false} borderColor="#f57c00">
        <div style={docSectionStyle}>
          <p style={docTextStyle}>
            Antes de enviar, o worker verifica duas regras obrigatorias:
          </p>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Regra 1: Percentual Minimo</h4>
          <p style={docTextStyle}>
            O percentual de exames prontos deve atingir o minimo configurado.
            Por padrao e <strong>100%</strong> (todos os exames devem estar prontos).
            Com <strong>Envio Inteligente (TAT)</strong> ativo, o percentual e aplicado apenas nos exames <strong>rapidos</strong>,
            ignorando medios e demorados.
          </p>
          <div style={{ ...docHighlightStyle, backgroundColor: '#fff3e0', border: '1px solid #ffe0b2' }}>
            <strong>Sem TAT:</strong> Protocolo com 10 exames. Se 8 estao prontos &#8594; 80% &#8594; <strong>aguarda</strong> (minimo 100%)<br />
            <strong>Com TAT:</strong> Protocolo com 7 rapidos e 3 demorados. Se 7/7 rapidos prontos &#8594; 100% &#8594; <strong>envia</strong> (demorados sao ignorados no calculo)
          </div>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Regra 2: Delay apos Digitacao</h4>
          <p style={docTextStyle}>
            Mesmo que 100% dos exames estejam prontos, o worker espera um tempo minimo (padrao: <strong>10 minutos</strong>)
            apos a digitacao do ultimo exame. Isso evita enviar a notificacao antes do resultado estar disponivel
            no servidor WMI/LifeSys para download do PDF.
          </p>
          <div style={{ ...docHighlightStyle, backgroundColor: '#fff3e0', border: '1px solid #ffe0b2' }}>
            <strong>Exemplo:</strong> Ultimo exame digitado as 10:50. Delay = 10 min.<br />
            Worker roda as 10:55 &#8594; faltam 5 min &#8594; <strong>aguarda</strong><br />
            Worker roda as 11:02 &#8594; ja passou &#8594; <strong>envia</strong>
          </div>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Filtros Adicionais</h4>
          <ul style={docListStyle}>
            <li><strong>Periodo Retroativo:</strong> Busca apenas solicitacoes dos ultimos N dias (configuravel, padrao 14)</li>
            <li><strong>Data de Corte:</strong> Se definida, ignora solicitacoes anteriores a essa data (usa o MAIOR entre data de corte e N dias atras)</li>
            <li><strong>Consentimento:</strong> Se ativado, so envia para pacientes com PACIENTE.ENVIA_WHATSAPP = T (campo do cadastro do paciente, nao da solicitacao)</li>
            <li><strong>Envio Inteligente (TAT):</strong> Classifica exames automaticamente por tempo real de resultado e aplica regras de envio por categoria (rapido, medio, demorado)</li>
            <li><strong>Limite por ciclo:</strong> Maximo de envios por ciclo (padrao 20) para evitar sobrecarga</li>
          </ul>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Controle de Envio e Reenvio" defaultOpen={false} borderColor="#7b1fa2">
        <div style={docSectionStyle}>
          <p style={docTextStyle}>
            O sistema controla o que ja foi enviado atraves da tabela <span style={docCodeStyle}>whatsapp_envios</span> no PostgreSQL.
            Cada envio grava:
          </p>
          <ul style={docListStyle}>
            <li>ID da solicitacao, telefone, template usado</li>
            <li>Data/hora do envio e status da API (enviado, erro, etc.)</li>
            <li><strong>Snapshot completo dos exames</strong> naquele momento (JSON com cada exame e sua situacao)</li>
          </ul>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Deteccao de Reenvio (Comparacao por Exame)</h4>
          <p style={docTextStyle}>
            Quando o worker encontra uma solicitacao que <strong>ja foi enviada</strong>, ele compara
            <strong> exame por exame</strong> (nao apenas a quantidade) entre o snapshot anterior e o estado atual:
          </p>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Situacao</th>
                <th style={docThStyle}>O que acontece</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: '#fff' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>Nenhum exame novo pronto</td>
                <td style={docTdStyle}>Ignora — nada mudou desde o ultimo envio</td>
              </tr>
              <tr style={{ backgroundColor: '#fafafa' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>Exames novos ficaram prontos</td>
                <td style={docTdStyle}>
                  <strong>Reenvio automatico</strong> — o sistema identifica quais exames especificos ficaram prontos
                  e disponibiliza seus nomes na variavel <span style={docCodeStyle}>{'{novos_exames}'}</span>
                </td>
              </tr>
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Exemplo Pratico Completo</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Momento</th>
                <th style={docThStyle}>Exames Prontos</th>
                <th style={docThStyle}>Acao do Worker</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['09:00', '3/10 (30%) — HEMOGRAMA, GLICOSE, UREIA', 'Aguarda (30% < 100%)'],
                ['10:00', '8/10 (80%) — + 5 exames prontos', 'Aguarda (80% < 100%)'],
                ['11:00', '10/10 (100%) — digitado ha 2 min', 'Aguarda delay (faltam 8 min)'],
                ['11:15', '10/10 (100%) — digitado ha 15 min', 'ENVIA (1o envio) — grava snapshot com 10 exames'],
                ['14:00', '10/10 (100%)', 'Ignora — mesmos exames que o snapshot anterior'],
                ['Dia seguinte', '12/12 — lab adicionou TSH e T4L', 'REENVIO — detecta TSH e T4L como novos exames prontos'],
              ].map(([momento, exames, acao], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontWeight: '600', whiteSpace: 'nowrap' }}>{momento}</td>
                  <td style={docTdStyle}>{exames}</td>
                  <td style={docTdStyle}>{acao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Variaveis Disponiveis para Templates" defaultOpen={false} borderColor="#0097a7">
        <div style={docSectionStyle}>
          <p style={docTextStyle}>
            As variaveis abaixo podem ser usadas nos templates WAHA (entre chaves) e nos templates Meta (mapeadas na configuracao).
            O sistema substitui automaticamente pelo valor correspondente no momento do envio.
          </p>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Dados do Paciente e Atendimento</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Variavel</th>
                <th style={docThStyle}>Descricao</th>
                <th style={docThStyle}>Exemplo</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['{nome_paciente}', 'Nome completo do paciente', 'JOAO DA SILVA'],
                ['{primeiro_nome}', 'Primeiro nome do paciente', 'JOAO'],
                ['{protocolo}', 'Numero do protocolo', '260133'],
                ['{data_atendimento}', 'Data do atendimento (dd/mm/aaaa)', '26/02/2026'],
                ['{local_nome}', 'Nome da unidade', 'Itapecerica'],
                ['{nome_laboratorio}', 'Nome do laboratorio (configuravel)', 'Laboratorio Santa Rita'],
                ['{link_resultado}', 'Link para acessar o resultado online', 'https://...'],
              ].map(([v, desc, ex], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontFamily: 'monospace', fontSize: '12px', color: '#c62828' }}>{v}</td>
                  <td style={docTdStyle}>{desc}</td>
                  <td style={{ ...docTdStyle, color: '#666', fontStyle: 'italic' }}>{ex}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Variaveis Compostas (para templates Meta)</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Variavel</th>
                <th style={docThStyle}>Conteudo</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['{protocolo_data}', '260133 de 26/02/2026'],
                ['{data_protocolo}', '26/02/2026, protocolo 260133'],
                ['{data_local}', '26/02/2026 na unidade Itapecerica'],
                ['{info_atendimento}', 'Protocolo 260133 - 26/02/2026'],
                ['{corpo_seu_exame}', 'Texto composto com protocolo + data + link para template "seu_exame_"'],
                ['{corpo_pedido_pronto}', 'Texto composto com data + protocolo + link para template "pedido_pronto"'],
                ['{acesse_link}', 'Acesse seus resultados: https://...'],
                ['{lab_assinatura}', 'Laboratorio Santa Rita - Cuidando da sua saude!'],
              ].map(([v, desc], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontFamily: 'monospace', fontSize: '12px', color: '#c62828' }}>{v}</td>
                  <td style={docTdStyle}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Variaveis de Exames (Snapshot)</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Variavel</th>
                <th style={docThStyle}>Descricao</th>
                <th style={docThStyle}>Exemplo</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['{total_exames}', 'Total de exames na solicitacao', '10'],
                ['{exames_prontos}', 'Quantidade de exames prontos', '10'],
                ['{status_exames}', 'Texto descritivo do status', 'Todos os seus 10 exame(s) estao prontos!'],
                ['{lista_exames}', 'Lista formatada de todos exames com status', 'HEMOGRAMA - pronto\\nGLICOSE - pronto'],
              ].map(([v, desc, ex], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontFamily: 'monospace', fontSize: '12px', color: '#c62828' }}>{v}</td>
                  <td style={docTdStyle}>{desc}</td>
                  <td style={{ ...docTdStyle, color: '#666', fontStyle: 'italic' }}>{ex}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '16px 0 10px' }}>Variaveis de Reenvio (Novos Exames)</h4>
          <div style={{ ...docHighlightStyle, backgroundColor: '#f3e5f5', border: '1px solid #ce93d8', marginBottom: '12px' }}>
            Disponiveis apenas em mensagens de <strong>reenvio</strong>, quando exames que nao estavam prontos no envio anterior ficaram prontos.
          </div>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Variavel</th>
                <th style={docThStyle}>Descricao</th>
                <th style={docThStyle}>Exemplo</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['{novos_exames}', 'Nomes dos novos exames prontos (virgula)', 'TSH, T4 LIVRE'],
                ['{novos_exames_lista}', 'Lista formatada dos novos exames', 'TSH\\nT4 LIVRE'],
                ['{novos_exames_qtd}', 'Quantidade de novos exames', '2'],
              ].map(([v, desc, ex], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontFamily: 'monospace', fontSize: '12px', color: '#c62828' }}>{v}</td>
                  <td style={docTdStyle}>{desc}</td>
                  <td style={{ ...docTdStyle, color: '#666', fontStyle: 'italic' }}>{ex}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Arquitetura Tecnica" defaultOpen={false} borderColor="#455a64">
        <div style={docSectionStyle}>
          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '0 0 10px' }}>Bancos de Dados</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Banco</th>
                <th style={docThStyle}>Dados</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: '#fff' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>SQL Server</td>
                <td style={docTdStyle}>
                  Dados do laboratorio: SOLICITACAO, SOLICITACAO_EXAMES (situacao, DATA_HORA_DIG),
                  PACIENTE (telefone), LAUDOS. Somente leitura pelo sistema WhatsApp.
                </td>
              </tr>
              <tr style={{ backgroundColor: '#fafafa' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>PostgreSQL</td>
                <td style={docTdStyle}>
                  Configuracoes (<span style={docCodeStyle}>whatsapp_config</span>),
                  agendamento (<span style={docCodeStyle}>whatsapp_agendamento</span>),
                  registro de envios (<span style={docCodeStyle}>whatsapp_envios</span> com snapshot),
                  conversas e mensagens recebidas, cache TAT.
                </td>
              </tr>
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Fluxo do Ciclo de Envio</h4>
          <div style={{ fontFamily: 'monospace', fontSize: '12px', lineHeight: '1.8', backgroundColor: '#f5f5f5', padding: '16px', borderRadius: '6px', overflowX: 'auto', whiteSpace: 'pre', color: '#333' }}>
{`cicloEnvioAutomatico()
  |
  +-- Verifica horario/dia permitido
  +-- Le config (PG) + cache TAT (PG)
  +-- Calcula dataCutoff = MAX(data_corte, N dias atras)
  |
  +-- Query SQL Server: TOP 200 solicitacoes
  |     WHERE data >= dataCutoff
  |     AND tem telefone
  |     AND tem pelo menos 1 exame pronto
  |
  +-- Para cada solicitacao:
        |
        +-- Verificar consentimento (se ativado)
        +-- Validar telefone
        +-- buildExamSnapshot() --> foto de TODOS os exames
        |     total, prontos, percentual, categorias TAT
        |
        +-- checkSendReadiness()
        |     TAT ativo? percentual dos RAPIDOS >= minimo?
        |     TAT inativo? percentual de TODOS >= minimo?
        |     Delay apos digitacao OK?
        |
        +-- verificarEnvioSolicitacao() (PG)
        |     Nunca enviou? --> ENVIO NOVO
        |     Ja enviou? --> compara exame por exame
        |       Novos exames prontos? --> REENVIO
        |       Mesmos exames? --> IGNORA
        |
        +-- montarVariaveis() --> {nome}, {protocolo}, {novos_exames}...
        +-- Enviar via WAHA ou Meta API
        +-- registrarEnvioWhatsApp() --> grava snapshot no PG
        +-- Delay 500ms entre envios (rate limit)`}
          </div>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Arquivos Principais</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Arquivo</th>
                <th style={docThStyle}>Responsabilidade</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['whatsapp-worker.js', 'Worker automatico: ciclo de envio, agendamento, preview "proximos envios"'],
                ['whatsapp-envios.js', 'Logica de envio: buildExamSnapshot, checkSendReadiness, montarVariaveis, enviar via WAHA/Meta'],
                ['whatsapp-config.js', 'API de configuracao: salvar/ler config, templates, agendamento'],
                ['whatsapp-webhook.js', 'Receber mensagens do WhatsApp (webhook Meta/WAHA)'],
                ['whatsapp-ai-agent.js', 'IA conversacional: tools de busca, resultados, coleta domiciliar'],
                ['auth-db.js', 'Funcoes PostgreSQL: registrarEnvio, verificarEnvio, getConfig, etc.'],
              ].map(([arq, desc], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontFamily: 'monospace', fontSize: '12px', fontWeight: '600' }}>{arq}</td>
                  <td style={docTdStyle}>{desc}</td>
                </tr>
              ))}
            </tbody>
          </table>

          <h4 style={{ fontSize: '14px', fontWeight: '600', color: '#333', margin: '20px 0 10px' }}>Provedores de Envio</h4>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Provedor</th>
                <th style={docThStyle}>Tipo</th>
                <th style={docThStyle}>Caracteristicas</th>
              </tr>
            </thead>
            <tbody>
              <tr style={{ backgroundColor: '#fff' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>WAHA</td>
                <td style={docTdStyle}>Self-hosted</td>
                <td style={docTdStyle}>Mensagem de texto livre (sem template aprovado). Suporta envio de PDF como anexo. Mais flexivel, porem usa WhatsApp Web.</td>
              </tr>
              <tr style={{ backgroundColor: '#fafafa' }}>
                <td style={{ ...docTdStyle, fontWeight: '600' }}>Meta Business API</td>
                <td style={docTdStyle}>Oficial</td>
                <td style={docTdStyle}>Requer templates pre-aprovados pela Meta. Variaveis mapeadas por posicao. Mais estavel e confiavel para producao.</td>
              </tr>
            </tbody>
          </table>
        </div>
      </CollapsibleSection>

      <CollapsibleSection title="Configuracoes e seus Efeitos" defaultOpen={false} borderColor="#c62828">
        <div style={docSectionStyle}>
          <table style={docTableStyle}>
            <thead>
              <tr>
                <th style={docThStyle}>Configuracao</th>
                <th style={docThStyle}>Onde</th>
                <th style={docThStyle}>Efeito</th>
                <th style={docThStyle}>Padrao</th>
              </tr>
            </thead>
            <tbody>
              {[
                ['Periodo Retroativo', 'Aba Regras', 'Quantos dias atras buscar solicitacoes no SQL Server', '14 dias'],
                ['Data de Corte', 'Aba Regras', 'Data absoluta minima — ignora tudo antes. Util ao ativar o sistema pela 1a vez', 'Nenhuma'],
                ['Delay de Envio', 'Aba Regras', 'Minutos a esperar apos digitacao do ultimo exame antes de enviar', '10 min'],
                ['Percentual Minimo', 'Aba Regras', 'Percentual de exames prontos necessario para disparar o envio', '100%'],
                ['Envio Inteligente TAT', 'Aba Regras', 'Classifica exames por tempo real e aplica regras diferenciadas (rapido/medio/demorado)', 'Desativado'],
                ['Consentimento', 'Aba Regras (agendamento)', 'Se ativado, so envia para pacientes com PACIENTE.ENVIA_WHATSAPP = T (cadastro do paciente)', 'Desativado'],
                ['Status Minimo', 'Aba Regras (agendamento)', 'Qual situacao minima do exame conta como "pronto" (D, F, I...)', 'I (Impresso)'],
                ['Limite por ciclo', 'Aba Regras (agendamento)', 'Maximo de mensagens enviadas por ciclo para evitar rate limit', '20'],
                ['Intervalo do ciclo', 'Aba Regras (agendamento)', 'De quantos em quantos minutos o worker verifica novos resultados', '5 min'],
                ['Horario permitido', 'Aba Regras (agendamento)', 'Janela de horario em que o worker pode enviar (ex: 08:00-18:00)', '07:00-19:00'],
                ['Dias da semana', 'Aba Regras (agendamento)', 'Dias em que o worker funciona (seg-sab, etc)', 'Seg a Sab'],
              ].map(([config, onde, efeito, padrao], i) => (
                <tr key={i} style={{ backgroundColor: i % 2 === 0 ? '#fff' : '#fafafa' }}>
                  <td style={{ ...docTdStyle, fontWeight: '600', whiteSpace: 'nowrap' }}>{config}</td>
                  <td style={{ ...docTdStyle, whiteSpace: 'nowrap', color: '#666' }}>{onde}</td>
                  <td style={docTdStyle}>{efeito}</td>
                  <td style={{ ...docTdStyle, whiteSpace: 'nowrap', fontFamily: 'monospace', fontSize: '12px' }}>{padrao}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </CollapsibleSection>
    </div>
  );

  return (
    <div className="data-page" style={containerStyle}>
      <div style={pageHeaderStyle}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
          <span style={pageIconStyle}>&#9881;&#65039;</span>
          <div>
            <h1 style={pageTitleStyle}>Configura&#231;&#227;o WhatsApp</h1>
            <p style={pageSubtitleStyle}>Conex&#227;o, templates e regras de envio</p>
          </div>
        </div>
      </div>

      {message && (
        <div style={messageStyle(message.tipo)}>
          {message.texto}
        </div>
      )}

      <div className="responsive-flex" style={tabContainerStyle}>
        <button type="button" style={activeTab === 'conexao' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('conexao')}>
          Conexão e API
        </button>
        <button type="button" style={activeTab === 'templates' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('templates')}>
          Templates e Mensagens
        </button>
        <button type="button" style={activeTab === 'regras' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('regras')}>
          Regras de Envio
        </button>
        <button type="button" style={activeTab === 'webhook' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('webhook')}>
          Webhook e Auto-Respostas
        </button>
        <button type="button" style={activeTab === 'como_funciona' ? tabActiveStyle : tabStyle}
          onClick={() => setActiveTab('como_funciona')}>
          Como Funciona
        </button>
      </div>

      {activeTab === 'conexao' && renderConfigAPI()}
      {activeTab === 'templates' && renderTemplatesEMensagens()}
      {activeTab === 'regras' && renderRegrasCompletas()}
      {activeTab === 'webhook' && renderWebhookAutoRespostas()}
      {activeTab === 'como_funciona' && renderComoFunciona()}
    </div>
  );
};

export default WhatsAppConfig;
